/*! 
*
* foundation.js 
*/
/*
 * Foundation Responsive Library
 * http://foundation.zurb.com
 * Copyright 2013, ZURB
 * Free to use under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
*/
var libFuncName=null;if("undefined"==typeof jQuery&&"undefined"==typeof Zepto&&"function"==typeof $)libFuncName=$;else if("function"==typeof jQuery)libFuncName=jQuery;else{if("function"!=typeof Zepto)throw new TypeError;libFuncName=Zepto}!function(t,e,o,n){"use strict";Array.prototype.filter||(Array.prototype.filter=function(t){if(null==this)throw new TypeError;var e=Object(this),o=e.length>>>0;if("function"==typeof t){for(var n=[],i=arguments[1],s=0;s<o;s++)if(s in e){var r=e[s];t&&t.call(i,r,s,e)&&n.push(r)}return n}}),Function.prototype.bind||(Function.prototype.bind=function(t){if("function"!=typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");var e=Array.prototype.slice.call(arguments,1),o=this,n=function(){},i=function(){return o.apply(this instanceof n&&t?this:t,e.concat(Array.prototype.slice.call(arguments)))};return n.prototype=this.prototype,i.prototype=new n,i}),Array.prototype.indexOf||(Array.prototype.indexOf=function(t){if(null==this)throw new TypeError;var e=Object(this),o=e.length>>>0;if(0===o)return-1;var n=0;if(arguments.length>1&&(n=Number(arguments[1]),n!=n?n=0:0!=n&&n!=1/0&&n!=-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n)))),n>=o)return-1;for(var i=n>=0?n:Math.max(o-Math.abs(n),0);i<o;i++)if(i in e&&e[i]===t)return i;return-1}),t.fn.stop=t.fn.stop||function(){return this},e.Foundation={name:"Foundation",version:"4.1.5",cache:{},init:function(e,o,n,i,s,r){var a,l=[e,n,i,s],c=[],r=r||!1;if(r&&(this.nc=r),this.rtl=/rtl/i.test(t("html").attr("dir")),this.scope=e||this.scope,o&&"string"==typeof o){if(/off/i.test(o))return this.off();if(a=o.split(" "),a.length>0)for(var u=a.length-1;u>=0;u--)c.push(this.init_lib(a[u],l))}else for(var p in this.libs)c.push(this.init_lib(p,l));return"function"==typeof o&&l.unshift(o),this.response_obj(c,l)},response_obj:function(t,e){for(var o=0,n=e.length;o<n;o++)if("function"==typeof e[o])return e[o]({errors:t.filter(function(t){if("string"==typeof t)return t})});return t},init_lib:function(t,e){return this.trap(function(){if(this.libs.hasOwnProperty(t))return this.patch(this.libs[t]),this.libs[t].init.apply(this.libs[t],e)}.bind(this),t)},trap:function(t,e){if(!this.nc)try{return t()}catch(o){return this.error({name:e,message:"could not be initialized",more:o.name+" "+o.message})}return t()},patch:function(t){this.fix_outer(t),t.scope=this.scope,t.rtl=this.rtl},inherit:function(t,e){for(var o=e.split(" "),n=o.length-1;n>=0;n--)this.lib_methods.hasOwnProperty(o[n])&&(this.libs[t.name][o[n]]=this.lib_methods[o[n]])},random_str:function(t){var e="0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".split("");t||(t=Math.floor(Math.random()*e.length));for(var o="",n=0;n<t;n++)o+=e[Math.floor(Math.random()*e.length)];return o},libs:{},lib_methods:{set_data:function(t,e){var o=[this.name,+new Date,Foundation.random_str(5)].join("-");return Foundation.cache[o]=e,t.attr("data-"+this.name+"-id",o),e},get_data:function(t){return Foundation.cache[t.attr("data-"+this.name+"-id")]},remove_data:function(e){e?(delete Foundation.cache[e.attr("data-"+this.name+"-id")],e.attr("data-"+this.name+"-id","")):t("[data-"+this.name+"-id]").each(function(){delete Foundation.cache[t(this).attr("data-"+this.name+"-id")],t(this).attr("data-"+this.name+"-id","")})},throttle:function(t,e){var o=null;return function(){var n=this,i=arguments;clearTimeout(o),o=setTimeout(function(){t.apply(n,i)},e)}},data_options:function(e){function o(t){return!isNaN(t-0)&&null!==t&&""!==t&&t!==!1&&t!==!0}function n(e){return"string"==typeof e?t.trim(e):e}var i,s,r={},a=(e.attr("data-options")||":").split(";"),l=a.length;for(i=l-1;i>=0;i--)s=a[i].split(":"),/true/i.test(s[1])&&(s[1]=!0),/false/i.test(s[1])&&(s[1]=!1),o(s[1])&&(s[1]=parseInt(s[1],10)),2===s.length&&s[0].length>0&&(r[n(s[0])]=n(s[1]));return r},delay:function(t,e){return setTimeout(t,e)},scrollTo:function(o,n,i){if(!(i<0)){var s=n-t(e).scrollTop(),r=s/i*10;this.scrollToTimerCache=setTimeout(function(){isNaN(parseInt(r,10))||(e.scrollTo(0,t(e).scrollTop()+r),this.scrollTo(o,n,i-10))}.bind(this),10)}},scrollLeft:function(t){if(t.length)return"scrollLeft"in t[0]?t[0].scrollLeft:t[0].pageXOffset},empty:function(t){if(t.length&&t.length>0)return!1;if(t.length&&0===t.length)return!0;for(var e in t)if(hasOwnProperty.call(t,e))return!1;return!0}},fix_outer:function(t){t.outerHeight=function(t,e){return"function"==typeof Zepto?t.height():"undefined"!=typeof e?t.outerHeight(e):t.outerHeight()},t.outerWidth=function(t){return"function"==typeof Zepto?t.width():"undefined"!=typeof bool?t.outerWidth(bool):t.outerWidth()}},error:function(t){return t.name+" "+t.message+"; "+t.more},off:function(){return t(this.scope).off(".fndtn"),t(e).off(".fndtn"),!0},zj:function(){try{return Zepto}catch(t){return jQuery}}()},t.fn.foundation=function(){var t=Array.prototype.slice.call(arguments,0);return this.each(function(){return Foundation.init.apply(Foundation,[this].concat(t)),this})}}(libFuncName,this,this.document),/*! 
*
* foundation.forms.js 
*/
function(t,e,o,n){"use strict";Foundation.libs.forms={name:"forms",version:"4.1.6",cache:{},settings:{disable_class:"no-custom",last_combo:null},init:function(e,o,n){return"object"==typeof o&&t.extend(!0,this.settings,o),"string"!=typeof o?(this.settings.init||this.events(),this.assemble(),this.settings.init):this[o].call(this,n)},assemble:function(){t('form.custom input[type="radio"]',t(this.scope)).not('[data-customforms="disabled"]').each(this.append_custom_markup),t('form.custom input[type="checkbox"]',t(this.scope)).not('[data-customforms="disabled"]').each(this.append_custom_markup),t("form.custom select",t(this.scope)).not('[data-customforms="disabled"]').not("[multiple=multiple]").each(this.append_custom_select)},events:function(){var n=this;t(this.scope).on("click.fndtn.forms","form.custom span.custom.checkbox",function(e){e.preventDefault(),e.stopPropagation(),n.toggle_checkbox(t(this))}).on("click.fndtn.forms","form.custom span.custom.radio",function(e){e.preventDefault(),e.stopPropagation(),n.toggle_radio(t(this))}).on("change.fndtn.forms",'form.custom select:not([data-customforms="disabled"])',function(e,o){n.refresh_custom_select(t(this),o)}).on("click.fndtn.forms","form.custom label",function(e){if(t(e.target).is("label")){var o,i,s=t("#"+n.escape(t(this).attr("for"))+':not([data-customforms="disabled"])');0!==s.length&&("checkbox"===s.attr("type")?(e.preventDefault(),o=t(this).find("span.custom.checkbox"),0==o.length&&(o=s.add(this).siblings("span.custom.checkbox").first()),n.toggle_checkbox(o)):"radio"===s.attr("type")&&(e.preventDefault(),i=t(this).find("span.custom.radio"),0==i.length&&(i=s.add(this).siblings("span.custom.radio").first()),n.toggle_radio(i)))}}).on("click.fndtn.forms","form.custom div.custom.dropdown a.current, form.custom div.custom.dropdown a.selector",function(e){var o=t(this),s=o.closest("div.custom.dropdown"),r=i(s,"select");if(s.hasClass("open")||t(n.scope).trigger("click"),e.preventDefault(),!1===r.is(":disabled"))return s.toggleClass("open"),s.hasClass("open")?t(n.scope).on("click.fndtn.forms.customdropdown",function(){s.removeClass("open"),t(n.scope).off(".fndtn.forms.customdropdown")}):t(n.scope).on(".fndtn.forms.customdropdown"),!1}).on("click.fndtn.forms touchend.fndtn.forms","form.custom div.custom.dropdown li",function(e){var o=t(this),n=o.closest("div.custom.dropdown"),s=i(n,"select"),r=0;if(e.preventDefault(),e.stopPropagation(),!t(this).hasClass("disabled")){t("div.dropdown").not(n).removeClass("open");var a=o.closest("ul").find("li.selected");a.removeClass("selected"),o.addClass("selected"),n.removeClass("open").find("a.current").text(o.text()),o.closest("ul").find("li").each(function(t){o[0]==this&&(r=t)}),s[0].selectedIndex=r,s.data("prevalue",a.html()),s.trigger("change")}}),t(e).on("keydown",function(e){var n=(o.activeElement,Foundation.libs.forms),i=t(".custom.dropdown.open");if(i.length>0){if(e.preventDefault(),13===e.which&&i.find("li.selected").trigger("click"),27===e.which&&i.removeClass("open"),e.which>=65&&e.which<=90){var s=n.go_to(i,e.which),r=i.find("li.selected");s&&(r.removeClass("selected"),n.scrollTo(s.addClass("selected"),300))}if(38===e.which){var r=i.find("li.selected"),a=r.prev(":not(.disabled)");a.length>0&&(a.parent()[0].scrollTop=a.parent().scrollTop()-n.outerHeight(a),r.removeClass("selected"),a.addClass("selected"))}else if(40===e.which){var r=i.find("li.selected"),s=r.next(":not(.disabled)");s.length>0&&(s.parent()[0].scrollTop=s.parent().scrollTop()+n.outerHeight(s),r.removeClass("selected"),s.addClass("selected"))}}}),this.settings.init=!0},go_to:function(t,e){var o=t.find("li"),n=o.length;if(n>0)for(var i=0;i<n;i++){var s=o.eq(i).text().charAt(0).toLowerCase();if(s===String.fromCharCode(e).toLowerCase())return o.eq(i)}},scrollTo:function(t,e){if(!(e<0)){var o=t.parent(),n=this.outerHeight(t),i=n*t.index()-o.scrollTop(),s=i/e*10;this.scrollToTimerCache=setTimeout(function(){isNaN(parseInt(s,10))||(o[0].scrollTop=o.scrollTop()+s,this.scrollTo(t,e-10))}.bind(this),10)}},append_custom_markup:function(e,o){var n=t(o),i=n.attr("type"),s=n.next("span.custom."+i);n.parent().hasClass("switch")||n.addClass("hidden-field"),0===s.length&&(s=t('<span class="custom '+i+'"></span>').insertAfter(n)),s.toggleClass("checked",n.is(":checked")),s.toggleClass("disabled",n.is(":disabled"))},append_custom_select:function(e,o){var n,i=Foundation.libs.forms,s=t(o),r=s.next("div.custom.dropdown"),a=r.find("ul"),l=(r.find(".current"),r.find(".selector")),c=s.find("option"),u=c.filter(":selected"),p=s.attr("class")?s.attr("class").split(" "):[],d=0,m="",f=!1;if(!s.hasClass(i.settings.disable_class)){if(0===r.length){var h=s.hasClass("small")?"small":s.hasClass("medium")?"medium":s.hasClass("large")?"large":s.hasClass("expand")?"expand":"";r=t('<div class="'+["custom","dropdown",h].concat(p).filter(function(t,e,o){return""!=t&&o.indexOf(t)==e}).join(" ")+'"><a href="#" class="selector"></a><ul /></div>'),l=r.find(".selector"),a=r.find("ul"),m=c.map(function(){return"<li>"+t(this).html()+"</li>"}).get().join(""),a.append(m),f=r.prepend('<a href="#" class="current">'+u.html()+"</a>").find(".current"),s.after(r).addClass("hidden-field")}else m=c.map(function(){return"<li>"+t(this).html()+"</li>"}).get().join(""),a.html("").append(m);if(i.assign_id(s,r),r.toggleClass("disabled",s.is(":disabled")),n=a.find("li"),i.cache[r.data("id")]=n.length,c.each(function(e){this.selected&&(n.eq(e).addClass("selected"),f&&f.html(t(this).html())),t(this).is(":disabled")&&n.eq(e).addClass("disabled")}),!r.is(".small, .medium, .large, .expand")){r.addClass("open");var i=Foundation.libs.forms;i.hidden_fix.adjust(a),d=i.outerWidth(n)>d?i.outerWidth(n):d,Foundation.libs.forms.hidden_fix.reset(),r.removeClass("open")}}},assign_id:function(t,e){var o=[+new Date,Foundation.random_str(5)].join("-");t.attr("data-id",o),e.attr("data-id",o)},refresh_custom_select:function(e,o){var n=this,i=0,s=e.next(),r=e.find("option"),a=s.find("li");(a.length!=this.cache[s.data("id")]||o)&&(s.find("ul").html(""),r.each(function(){var e=t("<li>"+t(this).html()+"</li>");s.find("ul").append(e)}),r.each(function(e){this.selected&&(s.find("li").eq(e).addClass("selected"),s.find(".current").html(t(this).html())),t(this).is(":disabled")&&s.find("li").eq(e).addClass("disabled")}),s.removeAttr("style").find("ul").removeAttr("style"),s.find("li").each(function(){s.addClass("open"),n.outerWidth(t(this))>i&&(i=n.outerWidth(t(this))),s.removeClass("open")}),a=s.find("li"),this.cache[s.data("id")]=a.length)},toggle_checkbox:function(t){var e=t.prev(),o=e[0];!1===e.is(":disabled")&&(o.checked=!o.checked,t.toggleClass("checked"),e.trigger("change"))},toggle_radio:function(t){var e=t.prev(),o=e.closest("form.custom"),n=e[0];!1===e.is(":disabled")&&(o.find('input[type="radio"][name="'+this.escape(e.attr("name"))+'"]').next().not(t).removeClass("checked"),t.hasClass("checked")||t.toggleClass("checked"),n.checked=t.hasClass("checked"),e.trigger("change"))},escape:function(t){return t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&")},hidden_fix:{tmp:[],hidden:null,adjust:function(e){var o=this;o.hidden=e.parents().andSelf().filter(":hidden"),o.hidden.each(function(){var e=t(this);o.tmp.push(e.attr("style")),e.css({visibility:"hidden",display:"block"})})},reset:function(){var e=this;e.hidden.each(function(o){var i=t(this),s=e.tmp[o];s===n?i.removeAttr("style"):i.attr("style",s)}),e.tmp=[],e.hidden=null}},off:function(){t(this.scope).off(".fndtn.forms")}};var i=function(e,o){for(var e=e.prev();e.length;){if(e.is(o))return e;e=e.prev()}return t()}}(Foundation.zj,this,this.document),/*! 
*
* jquery.imageslaoded.min.js 
*/
function(t,e){var o="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";t.fn.imagesLoaded=function(n){function i(){var e=t(d),o=t(m);l&&(m.length?l.reject(u,e,o):l.resolve(u)),t.isFunction(n)&&n.call(a,u,e,o)}function s(t){r(t.target,"error"===t.type)}function r(e,n){e.src===o||-1!==t.inArray(e,p)||(p.push(e),n?m.push(e):d.push(e),t.data(e,"imagesLoaded",{isBroken:n,src:e.src}),c&&l.notifyWith(t(e),[n,u,t(d),t(m)]),u.length===p.length&&(setTimeout(i),u.unbind(".imagesLoaded",s)))}var a=this,l=t.isFunction(t.Deferred)?t.Deferred():0,c=t.isFunction(l.notify),u=a.find("img").add(a.filter("img")),p=[],d=[],m=[];return t.isPlainObject(n)&&t.each(n,function(t,e){"callback"===t?n=e:l&&l[t](e)}),u.length?u.bind("load.imagesLoaded error.imagesLoaded",s).each(function(n,i){var s=i.src,a=t.data(i,"imagesLoaded");a&&a.src===s?r(i,a.isBroken):i.complete&&i.naturalWidth!==e?r(i,0===i.naturalWidth||0===i.naturalHeight):(i.readyState||i.complete)&&(i.src=o,i.src=s)}):i(),l?l.promise(a):a}}(jQuery),/*! 
*
* jquery.natural-res.js
*/
function(t){for(var e,o=["Width","Height"];e=o.pop();)!function(e,o){t.fn[e]=e in new Image?function(){return this[0][e]}:function(){var t,e,n=this[0];return"img"===n.tagName.toLowerCase()&&(t=new Image,t.src=n.src,e=t[o]),e}}("natural"+e,e.toLowerCase())}(jQuery),/*!

	Zoom v1.7.8 - 2013-07-30
	Enlarge images on click or mouseover.
	(c) 2013 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php

*/
function(t){var e={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",onZoomIn:!1,onZoomOut:!1};t.zoom=function(e,o,n){var i,s,r,a,l,c=t(e).css("position");return t(e).css({position:/(absolute|fixed)/.test(c)?c:"relative",overflow:"hidden"}),n.style.width=n.style.height="",t(n).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:n.width,height:n.height,border:"none",maxWidth:"none"}).appendTo(e),{init:function(){i=t(e).outerWidth(),s=t(e).outerHeight(),r=(n.width-i)/t(o).outerWidth(),a=(n.height-s)/t(o).outerHeight(),l=t(o).offset()},move:function(t){var e=t.pageX-l.left,o=t.pageY-l.top;o=Math.max(Math.min(o,s),0),e=Math.max(Math.min(e,i),0),n.style.left=e*-r+"px",n.style.top=o*-a+"px"}}},t.fn.zoom=function(o){return this.each(function(){var n,i=t.extend({},e,o||{}),s=i.target||this,r=this,a=document.createElement("img"),l=t(a),c="mousemove.zoom",u=!1;(i.url||(n=t(r).find("img"),n[0]&&(i.url=n.data("src")||n.attr("src")),i.url))&&(a.onload=function(){function e(e){n.init(),n.move(e),l.stop().fadeTo(t.support.opacity?i.duration:0,1,!!t.isFunction(i.onZoomIn)&&i.onZoomIn.call(a))}function o(){l.stop().fadeTo(i.duration,0,!!t.isFunction(i.onZoomOut)&&i.onZoomOut.call(a))}var n=t.zoom(s,r,a);"grab"===i.on?t(r).on("mousedown.zoom",function(i){1===i.which&&(t(document).one("mouseup.zoom",function(){o(),t(document).off(c,n.move)}),e(i),t(document).on(c,n.move),i.preventDefault())}):"click"===i.on?t(r).on("click.zoom",function(i){return u?void 0:(u=!0,e(i),t(document).on(c,n.move),t(document).one("click.zoom",function(){o(),u=!1,t(document).off(c,n.move)}),!1)}):"toggle"===i.on?t(r).on("click.zoom",function(t){u?o():e(t),u=!u}):(n.init(),t(r).on("mouseenter.zoom",e).on("mouseleave.zoom",o).on(c,n.move)),t.isFunction(i.callback)&&i.callback.call(a)},a.src=i.url,t(r).one("zoom.destroy",function(){t(r).off(".zoom"),l.remove()}))})},t.fn.zoom.defaults=e}(window.jQuery),/*!

 matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. Dual MIT/BSD license 

*/
window.matchMedia||(window.matchMedia=function(){"use strict";var t=window.styleMedia||window.media;if(!t){var e=document.createElement("style"),o=document.getElementsByTagName("script")[0],n=null;e.type="text/css",e.id="matchmediajs-test",o.parentNode.insertBefore(e,o),n="getComputedStyle"in window&&window.getComputedStyle(e,null)||e.currentStyle,t={matchMedium:function(t){var o="@media "+t+"{ #matchmediajs-test { width: 1px; } }";return e.styleSheet?e.styleSheet.cssText=o:e.textContent=o,"1px"===n.width}}}return function(e){return{matches:t.matchMedium(e||"all"),media:e||"all"}}}()),/*!
 *	jQuery OwlCarousel v1.31
 *
 *	Copyright (c) 2013 Bartosz Wojciechowski
 *	http://www.owlgraphic.com/owlcarousel/
 *
 *	Licensed under MIT
 *
 */
"function"!=typeof Object.create&&(Object.create=function(t){function e(){}return e.prototype=t,new e}),function(t,e,o,n){var i={init:function(e,o){var n=this;n.$elem=t(o),n.options=t.extend({},t.fn.owlCarousel.options,n.$elem.data(),e),n.userOptions=e,n.loadContent()},loadContent:function(){function e(t){if("function"==typeof o.options.jsonSuccess)o.options.jsonSuccess.apply(this,[t]);else{var e="";for(var n in t.owl)e+=t.owl[n].item;o.$elem.html(e)}o.logIn()}var o=this;if("function"==typeof o.options.beforeInit&&o.options.beforeInit.apply(this,[o.$elem]),"string"==typeof o.options.jsonPath){var n=o.options.jsonPath;t.getJSON(n,e)}else o.logIn()},logIn:function(t){var e=this;e.$elem.data("owl-originalStyles",e.$elem.attr("style")).data("owl-originalClasses",e.$elem.attr("class")),e.$elem.css({opacity:0}),e.orignalItems=e.options.items,e.checkBrowser(),e.wrapperWidth=0,e.checkVisible,e.setVars()},setVars:function(){var t=this;return 0!==t.$elem.children().length&&(t.baseClass(),t.eventTypes(),t.$userItems=t.$elem.children(),t.itemsAmount=t.$userItems.length,t.wrapItems(),t.$owlItems=t.$elem.find(".owl-item"),t.$owlWrapper=t.$elem.find(".owl-wrapper"),t.playDirection="next",t.prevItem=0,t.prevArr=[0],t.currentItem=0,t.customEvents(),void t.onStartup())},onStartup:function(){var t=this;t.updateItems(),t.calculateAll(),t.buildControls(),t.updateControls(),t.response(),t.moveEvents(),t.stopOnHover(),t.owlStatus(),t.options.transitionStyle!==!1&&t.transitionTypes(t.options.transitionStyle),t.options.autoPlay===!0&&(t.options.autoPlay=5e3),t.play(),t.$elem.find(".owl-wrapper").css("display","block"),t.$elem.is(":visible")?t.$elem.css("opacity",1):t.watchVisibility(),t.onstartup=!1,t.eachMoveUpdate(),"function"==typeof t.options.afterInit&&t.options.afterInit.apply(this,[t.$elem])},eachMoveUpdate:function(){var t=this;t.options.lazyLoad===!0&&t.lazyLoad(),t.options.autoHeight===!0&&t.autoHeight(),t.onVisibleItems(),"function"==typeof t.options.afterAction&&t.options.afterAction.apply(this,[t.$elem])},updateVars:function(){var t=this;"function"==typeof t.options.beforeUpdate&&t.options.beforeUpdate.apply(this,[t.$elem]),t.watchVisibility(),t.updateItems(),t.calculateAll(),t.updatePosition(),t.updateControls(),t.eachMoveUpdate(),"function"==typeof t.options.afterUpdate&&t.options.afterUpdate.apply(this,[t.$elem])},reload:function(t){var e=this;setTimeout(function(){e.updateVars()},0)},watchVisibility:function(){var t=this;return t.$elem.is(":visible")===!1&&(t.$elem.css({opacity:0}),clearInterval(t.autoPlayInterval),clearInterval(t.checkVisible),void(t.checkVisible=setInterval(function(){t.$elem.is(":visible")&&(t.reload(),t.$elem.animate({opacity:1},200),clearInterval(t.checkVisible))},500)))},wrapItems:function(){var t=this;t.$userItems.wrapAll('<div class="owl-wrapper">').wrap('<div class="owl-item"></div>'),t.$elem.find(".owl-wrapper").wrap('<div class="owl-wrapper-outer">'),t.wrapperOuter=t.$elem.find(".owl-wrapper-outer"),t.$elem.css("display","block")},baseClass:function(){var t=this,e=t.$elem.hasClass(t.options.baseClass),o=t.$elem.hasClass(t.options.theme);e||t.$elem.addClass(t.options.baseClass),o||t.$elem.addClass(t.options.theme)},updateItems:function(){var e=this;if(e.options.responsive===!1)return!1;if(e.options.singleItem===!0)return e.options.items=e.orignalItems=1,e.options.itemsCustom=!1,e.options.itemsDesktop=!1,e.options.itemsDesktopSmall=!1,e.options.itemsTablet=!1,e.options.itemsTabletSmall=!1,e.options.itemsMobile=!1,!1;var o=t(e.options.responsiveBaseWidth).width();if(o>(e.options.itemsDesktop[0]||e.orignalItems)&&(e.options.items=e.orignalItems),"undefined"!=typeof e.options.itemsCustom&&e.options.itemsCustom!==!1){e.options.itemsCustom.sort(function(t,e){return t[0]-e[0]});for(var n in e.options.itemsCustom)"undefined"!=typeof e.options.itemsCustom[n]&&e.options.itemsCustom[n][0]<=o&&(e.options.items=e.options.itemsCustom[n][1])}else o<=e.options.itemsDesktop[0]&&e.options.itemsDesktop!==!1&&(e.options.items=e.options.itemsDesktop[1]),o<=e.options.itemsDesktopSmall[0]&&e.options.itemsDesktopSmall!==!1&&(e.options.items=e.options.itemsDesktopSmall[1]),o<=e.options.itemsTablet[0]&&e.options.itemsTablet!==!1&&(e.options.items=e.options.itemsTablet[1]),o<=e.options.itemsTabletSmall[0]&&e.options.itemsTabletSmall!==!1&&(e.options.items=e.options.itemsTabletSmall[1]),o<=e.options.itemsMobile[0]&&e.options.itemsMobile!==!1&&(e.options.items=e.options.itemsMobile[1]);e.options.items>e.itemsAmount&&e.options.itemsScaleUp===!0&&(e.options.items=e.itemsAmount)},response:function(){var o,n=this;if(n.options.responsive!==!0)return!1;var i=t(e).width();n.resizer=function(){t(e).width()!==i&&(n.options.autoPlay!==!1&&clearInterval(n.autoPlayInterval),clearTimeout(o),o=setTimeout(function(){i=t(e).width(),n.updateVars()},n.options.responsiveRefreshRate))},t(e).resize(n.resizer)},updatePosition:function(){var t=this;t.jumpTo(t.currentItem),t.options.autoPlay!==!1&&t.checkAp()},appendItemsSizes:function(){var e=this,o=0,n=e.itemsAmount-e.options.items;e.$owlItems.each(function(i){var s=t(this);s.css({width:e.itemWidth}).data("owl-item",Number(i)),i%e.options.items!==0&&i!==n||i>n||(o+=1),s.data("owl-roundPages",o)})},appendWrapperSizes:function(){var t=this,e=0,e=t.$owlItems.length*t.itemWidth;t.$owlWrapper.css({width:2*e,left:0}),t.appendItemsSizes()},calculateAll:function(){var t=this;t.calculateWidth(),t.appendWrapperSizes(),t.loops(),t.max()},calculateWidth:function(){var t=this;t.itemWidth=Math.floor(t.$elem.width()/t.options.items)},max:function(){var t=this,e=(t.itemsAmount*t.itemWidth-t.options.items*t.itemWidth)*-1;return t.options.items>t.itemsAmount?(t.maximumItem=0,e=0,t.maximumPixels=0):(t.maximumItem=t.itemsAmount-t.options.items,t.maximumPixels=e),e},min:function(){return 0},loops:function(){var e=this;e.positionsInArray=[0],e.pagesInArray=[];for(var o=0,n=0,i=0;i<e.itemsAmount;i++)if(n+=e.itemWidth,e.positionsInArray.push(-n),e.options.scrollPerPage===!0){var s=t(e.$owlItems[i]),r=s.data("owl-roundPages");r!==o&&(e.pagesInArray[o]=e.positionsInArray[i],o=r)}},buildControls:function(){var e=this;e.options.navigation!==!0&&e.options.pagination!==!0||(e.owlControls=t('<div class="owl-controls"/>').toggleClass("clickable",!e.browser.isTouch).appendTo(e.$elem)),e.options.pagination===!0&&e.buildPagination(),e.options.navigation===!0&&e.buildButtons()},buildButtons:function(){var e=this,o=t('<div class="owl-buttons"/>');e.owlControls.append(o),e.buttonPrev=t("<div/>",{"class":"owl-prev",html:e.options.navigationText[0]||""}),e.buttonNext=t("<div/>",{"class":"owl-next",html:e.options.navigationText[1]||""}),o.append(e.buttonPrev).append(e.buttonNext),o.on("touchstart.owlControls mousedown.owlControls",'div[class^="owl"]',function(t){t.preventDefault()}),o.on("touchend.owlControls mouseup.owlControls",'div[class^="owl"]',function(o){o.preventDefault(),t(this).hasClass("owl-next")?e.next():e.prev()})},buildPagination:function(){var e=this;e.paginationWrapper=t('<div class="owl-pagination"/>'),e.owlControls.append(e.paginationWrapper),e.paginationWrapper.on("touchend.owlControls mouseup.owlControls",".owl-page",function(o){o.preventDefault(),Number(t(this).data("owl-page"))!==e.currentItem&&e.goTo(Number(t(this).data("owl-page")),!0)})},updatePagination:function(){var e=this;if(e.options.pagination===!1)return!1;e.paginationWrapper.html("");for(var o=0,n=e.itemsAmount-e.itemsAmount%e.options.items,i=0;i<e.itemsAmount;i++)if(i%e.options.items===0){if(o+=1,n===i)var s=e.itemsAmount-e.options.items;var r=t("<div/>",{"class":"owl-page"}),a=t("<span></span>",{text:e.options.paginationNumbers===!0?o:"","class":e.options.paginationNumbers===!0?"owl-numbers":""});r.append(a),r.data("owl-page",n===i?s:i),r.data("owl-roundPages",o),e.paginationWrapper.append(r)}e.checkPagination()},checkPagination:function(){var e=this;return e.options.pagination!==!1&&void e.paginationWrapper.find(".owl-page").each(function(o,n){t(this).data("owl-roundPages")===t(e.$owlItems[e.currentItem]).data("owl-roundPages")&&(e.paginationWrapper.find(".owl-page").removeClass("active"),t(this).addClass("active"))})},checkNavigation:function(){var t=this;return t.options.navigation!==!1&&void(t.options.rewindNav===!1&&(0===t.currentItem&&0===t.maximumItem?(t.buttonPrev.addClass("disabled"),t.buttonNext.addClass("disabled")):0===t.currentItem&&0!==t.maximumItem?(t.buttonPrev.addClass("disabled"),t.buttonNext.removeClass("disabled")):t.currentItem===t.maximumItem?(t.buttonPrev.removeClass("disabled"),t.buttonNext.addClass("disabled")):0!==t.currentItem&&t.currentItem!==t.maximumItem&&(t.buttonPrev.removeClass("disabled"),t.buttonNext.removeClass("disabled"))))},updateControls:function(){var t=this;t.updatePagination(),t.checkNavigation(),t.owlControls&&(t.options.items>=t.itemsAmount?t.owlControls.hide():t.owlControls.show())},destroyControls:function(){var t=this;t.owlControls&&t.owlControls.remove()},next:function(t){var e=this;if(e.isTransition)return!1;if(e.currentItem+=e.options.scrollPerPage===!0?e.options.items:1,e.currentItem>e.maximumItem+(1==e.options.scrollPerPage?e.options.items-1:0)){if(e.options.rewindNav!==!0)return e.currentItem=e.maximumItem,!1;e.currentItem=0,t="rewind"}e.goTo(e.currentItem,t)},prev:function(t){var e=this;if(e.isTransition)return!1;if(e.options.scrollPerPage===!0&&e.currentItem>0&&e.currentItem<e.options.items?e.currentItem=0:e.currentItem-=e.options.scrollPerPage===!0?e.options.items:1,e.currentItem<0){if(e.options.rewindNav!==!0)return e.currentItem=0,!1;e.currentItem=e.maximumItem,t="rewind"}e.goTo(e.currentItem,t)},goTo:function(t,e,o){var n=this;if(n.isTransition)return!1;if("function"==typeof n.options.beforeMove&&n.options.beforeMove.apply(this,[n.$elem]),t>=n.maximumItem?t=n.maximumItem:t<=0&&(t=0),n.currentItem=n.owl.currentItem=t,n.options.transitionStyle!==!1&&"drag"!==o&&1===n.options.items&&n.browser.support3d===!0)return n.swapSpeed(0),n.browser.support3d===!0?n.transition3d(n.positionsInArray[t]):n.css2slide(n.positionsInArray[t],1),n.afterGo(),n.singleItemTransition(),!1;var i=n.positionsInArray[t];n.browser.support3d===!0?(n.isCss3Finish=!1,e===!0?(n.swapSpeed("paginationSpeed"),setTimeout(function(){n.isCss3Finish=!0},n.options.paginationSpeed)):"rewind"===e?(n.swapSpeed(n.options.rewindSpeed),setTimeout(function(){n.isCss3Finish=!0},n.options.rewindSpeed)):(n.swapSpeed("slideSpeed"),setTimeout(function(){n.isCss3Finish=!0},n.options.slideSpeed)),n.transition3d(i)):e===!0?n.css2slide(i,n.options.paginationSpeed):"rewind"===e?n.css2slide(i,n.options.rewindSpeed):n.css2slide(i,n.options.slideSpeed),n.afterGo()},jumpTo:function(t){var e=this;"function"==typeof e.options.beforeMove&&e.options.beforeMove.apply(this,[e.$elem]),t>=e.maximumItem||t===-1?t=e.maximumItem:t<=0&&(t=0),e.swapSpeed(0),e.browser.support3d===!0?e.transition3d(e.positionsInArray[t]):e.css2slide(e.positionsInArray[t],1),e.currentItem=e.owl.currentItem=t,e.afterGo()},afterGo:function(){var t=this;t.prevArr.push(t.currentItem),t.prevItem=t.owl.prevItem=t.prevArr[t.prevArr.length-2],t.prevArr.shift(0),t.prevItem!==t.currentItem&&(t.checkPagination(),t.checkNavigation(),t.eachMoveUpdate(),t.options.autoPlay!==!1&&t.checkAp()),"function"==typeof t.options.afterMove&&t.prevItem!==t.currentItem&&t.options.afterMove.apply(this,[t.$elem])},stop:function(){var t=this;t.apStatus="stop",clearInterval(t.autoPlayInterval)},checkAp:function(){var t=this;"stop"!==t.apStatus&&t.play()},play:function(){var t=this;return t.apStatus="play",t.options.autoPlay!==!1&&(clearInterval(t.autoPlayInterval),void(t.autoPlayInterval=setInterval(function(){t.next(!0)},t.options.autoPlay)))},swapSpeed:function(t){var e=this;"slideSpeed"===t?e.$owlWrapper.css(e.addCssSpeed(e.options.slideSpeed)):"paginationSpeed"===t?e.$owlWrapper.css(e.addCssSpeed(e.options.paginationSpeed)):"string"!=typeof t&&e.$owlWrapper.css(e.addCssSpeed(t))},addCssSpeed:function(t){return{"-webkit-transition":"all "+t+"ms ease","-moz-transition":"all "+t+"ms ease","-o-transition":"all "+t+"ms ease",transition:"all "+t+"ms ease"}},removeTransition:function(){return{"-webkit-transition":"","-moz-transition":"","-o-transition":"",transition:""}},doTranslate:function(t){return{"-webkit-transform":"translate3d("+t+"px, 0px, 0px)","-moz-transform":"translate3d("+t+"px, 0px, 0px)","-o-transform":"translate3d("+t+"px, 0px, 0px)","-ms-transform":"translate3d("+t+"px, 0px, 0px)",transform:"translate3d("+t+"px, 0px,0px)"}},transition3d:function(t){var e=this;e.$owlWrapper.css(e.doTranslate(t))},css2move:function(t){var e=this;e.$owlWrapper.css({left:t})},css2slide:function(t,e){var o=this;o.isCssFinish=!1,o.$owlWrapper.stop(!0,!0).animate({left:t},{duration:e||o.options.slideSpeed,complete:function(){o.isCssFinish=!0}})},checkBrowser:function(){var t=this,n="translate3d(0px, 0px, 0px)",i=o.createElement("div");i.style.cssText="  -moz-transform:"+n+"; -ms-transform:"+n+"; -o-transform:"+n+"; -webkit-transform:"+n+"; transform:"+n;var s=/translate3d\(0px, 0px, 0px\)/g,r=i.style.cssText.match(s),a=null!==r&&1===r.length,l="ontouchstart"in e||navigator.msMaxTouchPoints;t.browser={support3d:a,isTouch:l}},moveEvents:function(){var t=this;t.options.mouseDrag===!1&&t.options.touchDrag===!1||(t.gestures(),t.disabledEvents())},eventTypes:function(){var t=this,e=["s","e","x"];t.ev_types={},t.options.mouseDrag===!0&&t.options.touchDrag===!0?e=["touchstart.owl mousedown.owl","touchmove.owl mousemove.owl","touchend.owl touchcancel.owl mouseup.owl"]:t.options.mouseDrag===!1&&t.options.touchDrag===!0?e=["touchstart.owl","touchmove.owl","touchend.owl touchcancel.owl"]:t.options.mouseDrag===!0&&t.options.touchDrag===!1&&(e=["mousedown.owl","mousemove.owl","mouseup.owl"]),t.ev_types.start=e[0],t.ev_types.move=e[1],t.ev_types.end=e[2]},disabledEvents:function(){var e=this;e.$elem.on("dragstart.owl",function(t){t.preventDefault()}),e.$elem.on("mousedown.disableTextSelect",function(e){return t(e.target).is("input, textarea, select, option")})},gestures:function(){function i(t){return t.touches?{x:t.touches[0].pageX,y:t.touches[0].pageY}:t.pageX!==n?{x:t.pageX,y:t.pageY}:{x:t.clientX,y:t.clientY}}function s(e){"on"===e?(t(o).on(c.ev_types.move,a),t(o).on(c.ev_types.end,l)):"off"===e&&(t(o).off(c.ev_types.move),t(o).off(c.ev_types.end))}function r(o){var o=o.originalEvent||o||e.event;if(3===o.which)return!1;if(!(c.itemsAmount<=c.options.items)){if(c.isCssFinish===!1&&!c.options.dragBeforeAnimFinish)return!1;if(c.isCss3Finish===!1&&!c.options.dragBeforeAnimFinish)return!1;c.options.autoPlay!==!1&&clearInterval(c.autoPlayInterval),c.browser.isTouch===!0||c.$owlWrapper.hasClass("grabbing")||c.$owlWrapper.addClass("grabbing"),c.newPosX=0,c.newRelativeX=0,t(this).css(c.removeTransition());var n=t(this).position();u.relativePos=n.left,u.offsetX=i(o).x-n.left,u.offsetY=i(o).y-n.top,s("on"),u.sliding=!1,u.targetElement=o.target||o.srcElement}}function a(n){var n=n.originalEvent||n||e.event;c.newPosX=i(n).x-u.offsetX,c.newPosY=i(n).y-u.offsetY,c.newRelativeX=c.newPosX-u.relativePos,"function"==typeof c.options.startDragging&&u.dragging!==!0&&0!==c.newRelativeX&&(u.dragging=!0,c.options.startDragging.apply(c,[c.$elem])),(c.newRelativeX>8||c.newRelativeX<-8&&c.browser.isTouch===!0)&&(n.preventDefault?n.preventDefault():n.returnValue=!1,u.sliding=!0),(c.newPosY>10||c.newPosY<-10)&&u.sliding===!1&&t(o).off("touchmove.owl");var s=function(){return c.newRelativeX/5},r=function(){return c.maximumPixels+c.newRelativeX/5};c.newPosX=Math.max(Math.min(c.newPosX,s()),r()),c.browser.support3d===!0?c.transition3d(c.newPosX):c.css2move(c.newPosX)}function l(o){var o=o.originalEvent||o||e.event;if(o.target=o.target||o.srcElement,u.dragging=!1,c.browser.isTouch!==!0&&c.$owlWrapper.removeClass("grabbing"),c.newRelativeX<0?c.dragDirection=c.owl.dragDirection="left":c.dragDirection=c.owl.dragDirection="right",0!==c.newRelativeX){var n=c.getNewPosition();if(c.goTo(n,!1,"drag"),u.targetElement===o.target&&c.browser.isTouch!==!0){t(o.target).on("click.disable",function(e){e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault(),t(o.target).off("click.disable")});var i=t._data(o.target,"events").click,r=i.pop();i.splice(0,0,r)}}s("off")}var c=this,u={offsetX:0,offsetY:0,baseElWidth:0,relativePos:0,position:null,minSwipe:null,maxSwipe:null,sliding:null,dargging:null,targetElement:null};c.isCssFinish=!0,c.$elem.on(c.ev_types.start,".owl-wrapper",r)},getNewPosition:function(){var t,e=this;return t=e.closestItem(),t>e.maximumItem?(e.currentItem=e.maximumItem,t=e.maximumItem):e.newPosX>=0&&(t=0,e.currentItem=0),t},closestItem:function(){var e=this,o=e.options.scrollPerPage===!0?e.pagesInArray:e.positionsInArray,n=e.newPosX,i=null;return t.each(o,function(s,r){n-e.itemWidth/20>o[s+1]&&n-e.itemWidth/20<r&&"left"===e.moveDirection()?(i=r,e.options.scrollPerPage===!0?e.currentItem=t.inArray(i,e.positionsInArray):e.currentItem=s):n+e.itemWidth/20<r&&n+e.itemWidth/20>(o[s+1]||o[s]-e.itemWidth)&&"right"===e.moveDirection()&&(e.options.scrollPerPage===!0?(i=o[s+1]||o[o.length-1],e.currentItem=t.inArray(i,e.positionsInArray)):(i=o[s+1],e.currentItem=s+1))}),e.currentItem},moveDirection:function(){var t,e=this;return e.newRelativeX<0?(t="right",e.playDirection="next"):(t="left",e.playDirection="prev"),t},customEvents:function(){var t=this;t.$elem.on("owl.next",function(){t.next()}),t.$elem.on("owl.prev",function(){t.prev()}),t.$elem.on("owl.play",function(e,o){t.options.autoPlay=o,t.play(),t.hoverStatus="play"}),t.$elem.on("owl.stop",function(){t.stop(),t.hoverStatus="stop"}),t.$elem.on("owl.goTo",function(e,o){t.goTo(o)}),t.$elem.on("owl.jumpTo",function(e,o){t.jumpTo(o)})},stopOnHover:function(){var t=this;t.options.stopOnHover===!0&&t.browser.isTouch!==!0&&t.options.autoPlay!==!1&&(t.$elem.on("mouseover",function(){t.stop()}),t.$elem.on("mouseout",function(){"stop"!==t.hoverStatus&&t.play()}))},lazyLoad:function(){var e=this;if(e.options.lazyLoad===!1)return!1;for(var o=0;o<e.itemsAmount;o++){var i=t(e.$owlItems[o]);if("loaded"!==i.data("owl-loaded")){var s,r=i.data("owl-item"),a=i.find(".lazyOwl");"string"==typeof a.data("src")?(i.data("owl-loaded")===n&&(a.hide(),i.addClass("loading").data("owl-loaded","checked")),s=e.options.lazyFollow!==!0||r>=e.currentItem,s&&r<e.currentItem+e.options.items&&a.length&&e.lazyPreload(i,a)):i.data("owl-loaded","loaded")}}},lazyPreload:function(t,e){function o(){s+=1,i.completeImg(e.get(0))||r===!0?n():s<=100?setTimeout(o,100):n()}function n(){t.data("owl-loaded","loaded").removeClass("loading"),e.removeAttr("data-src"),"fade"===i.options.lazyEffect?e.fadeIn(400):e.show(),"function"==typeof i.options.afterLazyLoad&&i.options.afterLazyLoad.apply(this,[i.$elem])}var i=this,s=0;if("DIV"===e.prop("tagName")){e.css("background-image","url("+e.data("src")+")");var r=!0}else e[0].src=e.data("src");o()},autoHeight:function(){function e(){r+=1,i.completeImg(s.get(0))?o():r<=100?setTimeout(e,100):i.wrapperOuter.css("height","")}function o(){var e=t(i.$owlItems[i.currentItem]).height();i.wrapperOuter.css("height",e+"px"),i.wrapperOuter.hasClass("autoHeight")||setTimeout(function(){i.wrapperOuter.addClass("autoHeight")},0)}var i=this,s=t(i.$owlItems[i.currentItem]).find("img");if(s.get(0)!==n){var r=0;e()}else o()},completeImg:function(t){return!!t.complete&&("undefined"==typeof t.naturalWidth||0!=t.naturalWidth)},onVisibleItems:function(){var e=this;e.options.addClassActive===!0&&e.$owlItems.removeClass("active"),e.visibleItems=[];for(var o=e.currentItem;o<e.currentItem+e.options.items;o++)e.visibleItems.push(o),e.options.addClassActive===!0&&t(e.$owlItems[o]).addClass("active");e.owl.visibleItems=e.visibleItems},transitionTypes:function(t){var e=this;e.outClass="owl-"+t+"-out",e.inClass="owl-"+t+"-in"},singleItemTransition:function(){function t(t,e){return{position:"relative",left:t+"px"}}var e=this;e.isTransition=!0;var o=e.outClass,n=e.inClass,i=e.$owlItems.eq(e.currentItem),s=e.$owlItems.eq(e.prevItem),r=Math.abs(e.positionsInArray[e.currentItem])+e.positionsInArray[e.prevItem],a=Math.abs(e.positionsInArray[e.currentItem])+e.itemWidth/2;e.$owlWrapper.addClass("owl-origin").css({"-webkit-transform-origin":a+"px","-moz-perspective-origin":a+"px","perspective-origin":a+"px"});var l="webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend";s.css(t(r,10)).addClass(o).on(l,function(){e.endPrev=!0,s.off(l),e.clearTransStyle(s,o)}),i.addClass(n).on(l,function(){e.endCurrent=!0,i.off(l),e.clearTransStyle(i,n)})},clearTransStyle:function(t,e){var o=this;t.css({position:"",left:""}).removeClass(e),o.endPrev&&o.endCurrent&&(o.$owlWrapper.removeClass("owl-origin"),o.endPrev=!1,o.endCurrent=!1,o.isTransition=!1)},owlStatus:function(){var t=this;t.owl={userOptions:t.userOptions,baseElement:t.$elem,userItems:t.$userItems,owlItems:t.$owlItems,currentItem:t.currentItem,prevItem:t.prevItem,visibleItems:t.visibleItems,isTouch:t.browser.isTouch,browser:t.browser,dragDirection:t.dragDirection}},clearEvents:function(){var n=this;n.$elem.off(".owl owl mousedown.disableTextSelect"),t(o).off(".owl owl"),t(e).off("resize",n.resizer)},unWrap:function(){var t=this;0!==t.$elem.children().length&&(t.$owlWrapper.unwrap(),t.$userItems.unwrap().unwrap(),t.owlControls&&t.owlControls.remove()),t.clearEvents(),t.$elem.attr("style",t.$elem.data("owl-originalStyles")||"").attr("class",t.$elem.data("owl-originalClasses"))},destroy:function(){var t=this;t.stop(),clearInterval(t.checkVisible),t.unWrap(),t.$elem.removeData()},reinit:function(e){var o=this,n=t.extend({},o.userOptions,e);o.unWrap(),o.init(n,o.$elem)},addItem:function(t,e){var o,i=this;return!!t&&(0===i.$elem.children().length?(i.$elem.append(t),i.setVars(),!1):(i.unWrap(),o=e===n||e===-1?-1:e,o>=i.$userItems.length||o===-1?i.$userItems.eq(-1).after(t):i.$userItems.eq(o).before(t),void i.setVars()))},removeItem:function(t){var e,o=this;return 0!==o.$elem.children().length&&(e=t===n||t===-1?-1:t,o.unWrap(),o.$userItems.eq(e).remove(),void o.setVars())}};t.fn.owlCarousel=function(e){return this.each(function(){if(t(this).data("owl-init")===!0)return!1;t(this).data("owl-init",!0);var o=Object.create(i);o.init(e,this),t.data(this,"owlCarousel",o)})},t.fn.owlCarousel.options={items:5,itemsCustom:!1,itemsDesktop:[1199,4],itemsDesktopSmall:[979,3],itemsTablet:[768,2],itemsTabletSmall:!1,itemsMobile:[479,1],singleItem:!1,itemsScaleUp:!1,slideSpeed:200,paginationSpeed:800,rewindSpeed:1e3,autoPlay:!1,stopOnHover:!1,navigation:!1,navigationText:["prev","next"],rewindNav:!0,scrollPerPage:!1,pagination:!0,paginationNumbers:!1,responsive:!0,responsiveRefreshRate:200,responsiveBaseWidth:e,baseClass:"owl-carousel",theme:"owl-theme",lazyLoad:!1,lazyFollow:!0,lazyEffect:"fade",autoHeight:!1,jsonPath:!1,jsonSuccess:!1,dragBeforeAnimFinish:!0,mouseDrag:!0,touchDrag:!0,addClassActive:!1,transitionStyle:!1,beforeUpdate:!1,afterUpdate:!1,beforeInit:!1,afterInit:!1,beforeMove:!1,afterMove:!1,afterAction:!1,startDragging:!1,afterLazyLoad:!1}}(jQuery,window,document),/*!
 *
 * Spin.js
 * Copyright (c) 2011-2013 Felix Gnass
 * Licensed under the MIT license
 */
function(t,e){"object"==typeof exports?module.exports=e():"function"==typeof define&&define.amd?define(e):t.Spinner=e()}(this,function(){"use strict";function t(t,e){var o,n=document.createElement(t||"div");for(o in e)n[o]=e[o];return n}function e(t){for(var e=1,o=arguments.length;e<o;e++)t.appendChild(arguments[e]);return t}function o(t,e,o,n){var i=["opacity",e,~~(100*t),o,n].join("-"),s=.01+o/n*100,r=Math.max(1-(1-t)/e*(100-s),t),a=u.substring(0,u.indexOf("Animation")).toLowerCase(),l=a&&"-"+a+"-"||"";return d[i]||(m.insertRule("@"+l+"keyframes "+i+"{0%{opacity:"+r+"}"+s+"%{opacity:"+t+"}"+(s+.01)+"%{opacity:1}"+(s+e)%100+"%{opacity:"+t+"}100%{opacity:"+r+"}}",m.cssRules.length),d[i]=1),i}function n(t,e){var o,n,i=t.style;for(e=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<p.length;n++)if(o=p[n]+e,void 0!==i[o])return o;if(void 0!==i[e])return e}function i(t,e){for(var o in e)t.style[n(t,o)||o]=e[o];return t}function s(t){for(var e=1;e<arguments.length;e++){var o=arguments[e];for(var n in o)void 0===t[n]&&(t[n]=o[n])}return t}function r(t){for(var e={x:t.offsetLeft,y:t.offsetTop};t=t.offsetParent;)e.x+=t.offsetLeft,e.y+=t.offsetTop;return e}function a(t,e){return"string"==typeof t?t:t[e%t.length]}function l(t){return"undefined"==typeof this?new l(t):void(this.opts=s(t||{},l.defaults,f))}function c(){function o(e,o){return t("<"+e+' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">',o)}m.addRule(".spin-vml","behavior:url(#default#VML)"),l.prototype.lines=function(t,n){function s(){return i(o("group",{coordsize:u+" "+u,coordorigin:-c+" "+-c}),{width:u,height:u})}function r(t,r,l){e(d,e(i(s(),{rotation:360/n.lines*t+"deg",left:~~r}),e(i(o("roundrect",{arcsize:n.corners}),{width:c,height:n.width,left:n.radius,top:-n.width>>1,filter:l}),o("fill",{color:a(n.color,t),opacity:n.opacity}),o("stroke",{opacity:0}))))}var l,c=n.length+n.width,u=2*c,p=2*-(n.width+n.length)+"px",d=i(s(),{position:"absolute",top:p,left:p});if(n.shadow)for(l=1;l<=n.lines;l++)r(l,-2,"progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");for(l=1;l<=n.lines;l++)r(l);return e(t,d)},l.prototype.opacity=function(t,e,o,n){var i=t.firstChild;n=n.shadow&&n.lines||0,i&&e+n<i.childNodes.length&&(i=i.childNodes[e+n],i=i&&i.firstChild,i=i&&i.firstChild,i&&(i.opacity=o))}}var u,p=["webkit","Moz","ms","O"],d={},m=function(){var o=t("style",{type:"text/css"});return e(document.getElementsByTagName("head")[0],o),o.sheet||o.styleSheet}(),f={lines:12,length:7,width:5,radius:10,rotate:0,corners:1,color:"#000",direction:1,speed:1,trail:100,opacity:.25,fps:20,zIndex:2e9,className:"spinner",top:"auto",left:"auto",position:"relative"};l.defaults={},s(l.prototype,{spin:function(e){this.stop();var o,n,s=this,a=s.opts,l=s.el=i(t(0,{className:a.className}),{position:a.position,width:0,zIndex:a.zIndex}),c=a.radius+a.length+a.width;if(e&&(e.insertBefore(l,e.firstChild||null),n=r(e),o=r(l),i(l,{left:("auto"==a.left?n.x-o.x+(e.offsetWidth>>1):parseInt(a.left,10)+c)+"px",top:("auto"==a.top?n.y-o.y+(e.offsetHeight>>1):parseInt(a.top,10)+c)+"px"})),l.setAttribute("role","progressbar"),s.lines(l,s.opts),!u){var p,d=0,m=(a.lines-1)*(1-a.direction)/2,f=a.fps,h=f/a.speed,v=(1-a.opacity)/(h*a.trail/100),g=h/a.lines;!function w(){d++;for(var t=0;t<a.lines;t++)p=Math.max(1-(d+(a.lines-t)*g)%h*v,a.opacity),s.opacity(l,t*a.direction+m,p,a);s.timeout=s.el&&setTimeout(w,~~(1e3/f))}()}return s},stop:function(){var t=this.el;return t&&(clearTimeout(this.timeout),t.parentNode&&t.parentNode.removeChild(t),this.el=void 0),this},lines:function(n,s){function r(e,o){return i(t(),{position:"absolute",width:s.length+s.width+"px",height:s.width+"px",background:e,boxShadow:o,transformOrigin:"left",transform:"rotate("+~~(360/s.lines*c+s.rotate)+"deg) translate("+s.radius+"px,0)",borderRadius:(s.corners*s.width>>1)+"px"})}for(var l,c=0,p=(s.lines-1)*(1-s.direction)/2;c<s.lines;c++)l=i(t(),{position:"absolute",top:1+~(s.width/2)+"px",transform:s.hwaccel?"translate3d(0,0,0)":"",opacity:s.opacity,animation:u&&o(s.opacity,s.trail,p+c*s.direction,s.lines)+" "+1/s.speed+"s linear infinite"}),s.shadow&&e(l,i(r("#000","0 0 4px #000"),{top:"2px"})),e(n,e(l,r(a(s.color,c),"0 0 1px rgba(0,0,0,.1)")));return n},opacity:function(t,e,o){e<t.childNodes.length&&(t.childNodes[e].style.opacity=o)}});var h=i(t("group"),{behavior:"url(#default#VML)"});return!n(h,"transform")&&h.adj?c():u=n(h,"animation"),l}),function(t){if("object"==typeof exports)t(require("jquery"),require("spin"));else if("function"==typeof define&&define.amd)define(["jquery","spin"],t);else{if(!window.Spinner)throw new Error("Spin.js not present");t(window.jQuery,window.Spinner)}}(function(t,e){t.fn.spin=function(o,n){return this.each(function(){var i=t(this),s=i.data();s.spinner&&(s.spinner.stop(),delete s.spinner),o!==!1&&(o=t.extend({color:n||i.css("color")},t.fn.spin.presets[o]||o),s.spinner=new e(o).spin(this))})},t.fn.spin.presets={tiny:{lines:8,length:2,width:2,radius:3},small:{lines:8,length:4,width:3,radius:5},large:{lines:10,length:8,width:4,radius:8}}});
(function() {
  var Accordion, Cart, Collection, DOC, Footer, FrameworkAlign, FullscreenSlider, HEADER, Header, HorizontalTabs, InstagramFeed, MediaQueries, PAGE, Password, Popup, ProductGrid, ProductModal, ProductPage, ProductSlider, PromoBar, VerticalTabs, VideoModal, WINDOW, current_window, log, mq_large, mq_medium, mq_small, touchevents_exist,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  FrameworkAlign = (function() {
    function FrameworkAlign(element1, type1) {
      this.element = element1;
      this.type = type1;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.fillYSpace = bind(this.fillYSpace, this);
      this.checkOverlap = bind(this.checkOverlap, this);
      this.createOverlapDetectors = bind(this.createOverlapDetectors, this);
      this.position = bind(this.position, this);
      this.parent = this.element.parent();
      this.left_side_border;
      this.right_element_width = null;
      this.position();
      this.fillYSpace();
      this.createOverlapDetectors();
      this.resizeListeners();
    }

    FrameworkAlign.prototype.position = function() {
      if (this.type === 'center-x') {
        if (!Modernizr.csstransforms) {
          this.element.css({
            'margin-left': -(this.element.outerWidth() / 2)
          });
        }
      }
      if (this.type === 'center-y') {
        if (!Modernizr.csstransforms) {
          return this.element.css({
            'margin-top': -(this.element.outerHeight() / 2)
          });
        }
      }
    };

    FrameworkAlign.prototype.createOverlapDetectors = function() {
      var _this;
      _this = this;
      if (_this.type === 'right') {
        return this.right_element_width = _this.element.outerWidth();
      }
    };

    FrameworkAlign.prototype.checkOverlap = function() {
      var _this, left_element, left_side_border, right_side_border;
      _this = this;
      if (_this.type === 'right') {
        _this.parent.removeClass('overlap');
        left_element = _this.parent.children().eq(_this.element.index() - 1);
        left_side_border = left_element.position().left + left_element.outerWidth();
        right_side_border = _this.parent.outerWidth() - _this.right_element_width;
        if (left_side_border >= right_side_border) {
          return _this.parent.addClass('overlap');
        }
      }
    };

    FrameworkAlign.prototype.fillYSpace = function() {
      var _this, container_height, text_panel_height;
      _this = this;
      if (_this.type === 'fill-y--dynamic') {
        container_height = _this.parent.outerHeight();
        text_panel_height = _this.parent.find('.fw--align--fill-y--fixed').outerHeight();
        return _this.element.outerHeight(container_height - text_panel_height);
      }
    };

    FrameworkAlign.prototype.resizeListeners = function() {
      var _this;
      _this = this;
      $(window).on('resize.FrameworkAlign', function() {
        _this.checkOverlap();
        return _this.fillYSpace();
      });
      return setTimeout(function() {
        return _this.checkOverlap();
      }, 1);
    };

    return FrameworkAlign;

  })();

  theme.classes.FrameworkAnimation = (function() {
    function FrameworkAnimation() {}

    return FrameworkAnimation;

  })();

  theme.classes.FrameworkCart = (function() {
    function FrameworkCart(container1, mq) {
      this.container = container1;
      this.mq = mq;
      this.convertCurrency = bind(this.convertCurrency, this);
      this.openModalListener = bind(this.openModalListener, this);
      this.openOffCanvasListener = bind(this.openOffCanvasListener, this);
      this.removeItem = bind(this.removeItem, this);
      this.removeItemListeners = bind(this.removeItemListeners, this);
      this.updateTotals = bind(this.updateTotals, this);
      this.plusQuantity = bind(this.plusQuantity, this);
      this.minusQuantity = bind(this.minusQuantity, this);
      this.updateQuantityListeners = bind(this.updateQuantityListeners, this);
      this.addItem = bind(this.addItem, this);
      this.renderOther = bind(this.renderOther, this);
      this.renderListener = bind(this.renderListener, this);
      this.renderCart = bind(this.renderCart, this);
      this.adjusting_qty_timer = null;
      this.table_content = this.container.find('form > .content');
      this.render_trigger = $('.fw--cart-modal--trigger-render');
      this.totals = {};
      this.add_locked = false;
      this.render_locked = false;
      if (this.container.hasClass('off-canvas')) {
        this.view = 'off canvas';
      }
      if (this.container.hasClass('modal--content')) {
        this.view = 'modal';
      }
      this.temp_quantity = 0;
      this.renderCart();
      if (this.view === 'off canvas') {
        this.openOffCanvasListener();
      }
      this.openModalListener();
      this.renderListener();
    }

    FrameworkCart.prototype.renderCart = function(callback) {
      var _this;
      _this = this;
      if (!_this.render_locked) {
        _this.render_locked = true;
        _this.table_content.empty();
        return $.ajax({
          type: "POST",
          url: "/cart.js",
          dataType: "json"
        }).done(function(data, textStatus, jqXHR) {
          var cart, index, item, j, len1, ref, row;
          if (textStatus === 'success') {
            cart = data;
            if (cart.items.length) {
              _this.container.removeClass('no-items');
            } else {
              _this.container.addClass('no-items');
            }
            ref = cart.items;
            for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
              item = ref[index];
              item.image_url = Shopify.resizeImage(item.image, "medium");
              item.price = Currency.formatMoney(item.price, theme.money_format);
              if ((index + 1) === cart.items.length) {
                row = '<div class="variant-id last-variant width--12" data-variant-id=' + item.variant_id + '>';
              } else {
                row = '<div class="variant-id width--12" data-variant-id=' + item.variant_id + '>';
              }
              row += '<div class="width--12 width--medium-4 width--large-6 block">';
              if (item.image_url === null) {
                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"></span>';
              } else {
                row += '<span class="image block width--4 width--medium-12 width--large-4 spacing--3"><a href="' + item.url + '"><img src="' + item.image_url + '" alt="' + item.title + '"></a></span>';
              }
              row += '<span class="title show--small show--large block width--8 spacing--3 font--size-4"><a href="' + item.url + '">' + item.title + '</a></span>';
              row += '</div>';
              row += '<div class="right-column width--12 width--medium-8 width--large-6 block spacing--3y text-align--left text-align--large-right">';
              row += '<span class="title show--medium block width--12 spacing--3 font--size-4"><a href="' + item.url + '">' + item.title + '</a></span>';
              row += '<span class="price font--accent spacing--3 font--size-3 money">' + item.price + '</span>';
              row += '<span class="quantity spacing--3"><div class="input--number">';
              row += '<a tabindex="0" aria-label="' + theme.translations.remove_one_item + '" class="minus">' + theme.utils.addSymbol('minus') + '</a>';
              row += '<input type="text" value="' + item.quantity + '" min="1" pattern="[1-9]*">';
              row += '<a tabindex="0" aria-label="' + theme.translations.add_one_item + '" class="plus">' + theme.utils.addSymbol('plus') + '</a>';
              row += '</div></span>';
              row += '<span class="remove spacing--3">';
              row += '<a aria-label="' + theme.translations.remove_item + '" role="button" href="#" class="cart--remove-button remove">' + theme.utils.addSymbol('cross-circle') + '</a>';
              row += '</span>';
              row += '</div>';
              row += '</div>';
              row += '<div class="spacer spacing--3y"></div>';
              _this.table_content.append(row);
            }
            row = '<div class="totals width--12 text-align--center ">';
            row += '<div class="width--12 width--large-8 block">';
            row += '</div>';
            row += '<div class="block spacing--3y width--12 width--large-4 font--size-3 text--bold text-align--large-right text--uppercase">';
            row += '<span class="spacing--3">' + theme.translations.cart_subtotal + '</span>';
            row += '<span class="total spacing--3 money font--accent font--subheading--size">' + _this.totals.price + '</span>';
            row += '</div>';
            row += '</div>';
            row += '<div class="spacer spacing--3y show--small-medium"></div>';
            _this.table_content.append(row);
            _this.updateTotals();
            if (window.Shopify && Shopify.StorefrontExpressButtons) {
              Shopify.StorefrontExpressButtons.initialize();
            }
            if (callback) {
              callback();
            }
            $(window).trigger('resize.FrameworkModal');
            _this.render_locked = false;
            _this.removeItemListeners();
            _this.updateQuantityListeners();
            return _this.convertCurrency(_this.container.find('.money'));
          } else {
            return console.log('cart - render item status - ' + textStatus);
          }
        }).fail(function(jqXHR, textStatus) {
          console.log("cart rendering failed");
          return _this.render_locked = false;
        });
      }
    };

    FrameworkCart.prototype.renderListener = function() {
      var _this;
      _this = this;
      return this.container.on('renderCart', function() {
        return _this.renderCart();
      });
    };

    FrameworkCart.prototype.renderOther = function() {
      if (this.mq.current_window === 'small') {
        return $('.fw--cart.modal--content').trigger('renderCart');
      } else {
        return $('.fw--cart.off-canvas').trigger('renderCart');
      }
    };

    FrameworkCart.prototype.addItem = function(form, callback) {
      var _this;
      _this = this;
      if (!_this.add_locked) {
        _this.add_locked = true;
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: form.serialize()
        }).done(function(data, textStatus, jqXHR) {
          callback(true);
          _this.renderOther();
          return _this.add_locked = false;
        }).fail(function(jqXHR, textStatus) {
          callback(false, jqXHR.responseJSON.description);
          return _this.add_locked = false;
        });
      }
    };

    FrameworkCart.prototype.updateQuantityListeners = function() {
      var _this;
      _this = this;
      this.table_content.find('.input--number input').attr("autocomplete", "off").on('keyup.LayoutCartModal paste.LayoutCartModal', function() {
        var input, input_wrapper, variant_id;
        input_wrapper = $(this).closest('.input--number');
        input = input_wrapper.find('input');
        if (parseInt(input.val()) > 0) {
          input_wrapper.addClass('updating');
          clearTimeout(_this.adjusting_qty_timer);
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.adjusting_qty_timer = setTimeout(function() {
            _this.updateCart(variant_id, parseInt(input.val()));
            input_wrapper.removeClass('updating');
            return _this.updateTotals();
          }, 500);
        } else if (parseInt(input.val()) === 0) {
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.removeItem(variant_id);
          if ($(this).closest('form').find('.variant-id').length === 1) {
            _this.container.addClass('no-items');
          } else {
            $(this).closest('.variant-id').remove();
          }
        }
        return false;
      });
      this.table_content.find('.input--number .minus').on('keypress.LayoutCartModal click.LayoutCartModal', function(e) {
        var input, input_wrapper, variant_id;
        if (theme.utils.a11yClick(e) === true) {
          input_wrapper = $(this).closest('.input--number');
          input = input_wrapper.find('input');
          if (parseInt(input.val()) > 1) {
            input_wrapper.addClass('updating');
            clearTimeout(_this.adjusting_qty_timer);
            input.val(parseInt(input.val()) - 1);
            variant_id = $(this).closest('.variant-id').data('variant-id');
            _this.adjusting_qty_timer = setTimeout(function() {
              _this.minusQuantity(variant_id, parseInt(input.val()));
              input_wrapper.removeClass('updating');
              return _this.updateTotals();
            }, 500);
          }
          return false;
        }
      });
      return this.table_content.find('.input--number .plus').on('keypress.LayoutCartModal click.LayoutCartModal', function(e) {
        var input, input_wrapper, variant_id;
        if (theme.utils.a11yClick(e) === true) {
          clearTimeout(_this.adjusting_qty_timer);
          input_wrapper = $(this).closest('.input--number');
          input = input_wrapper.find('input');
          if (_this.temp_quantity === 0) {
            _this.temp_quantity = parseInt(input.val());
          }
          input_wrapper.addClass('updating');
          input.val(1 + parseInt(input.val()));
          variant_id = $(this).closest('.variant-id').data('variant-id');
          _this.adjusting_qty_timer = setTimeout(function() {
            var add_quantity;
            add_quantity = parseInt(input.val()) - _this.temp_quantity;
            return _this.plusQuantity(variant_id, add_quantity, function(pass, error) {
              if (pass) {
                input_wrapper.removeClass('updating');
                _this.updateTotals();
                return _this.temp_quantity = 0;
              } else {
                input.val(_this.temp_quantity);
                input_wrapper.removeClass('updating');
                _this.updateTotals();
                return _this.temp_quantity = 0;
              }
            });
          }, 500);
          return false;
        }
      });
    };

    FrameworkCart.prototype.minusQuantity = function(variant_id, quantity) {
      var _this;
      _this = this;
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: 'quantity=' + quantity + '&id=' + variant_id,
        async: false
      }).done(function(data, textStatus, jqXHR) {
        if (textStatus === 'success') {
          _this.updateTotals();
          return _this.renderOther();
        } else {
          return console.log('cart - update cart item status - ' + textStatus);
        }
      }).fail(function(jqXHR, textStatus) {
        return console.log("cart - update failed");
      });
    };

    FrameworkCart.prototype.plusQuantity = function(variant_id, quantity, callback) {
      var _this;
      _this = this;
      if (!_this.add_locked) {
        _this.add_locked = true;
        return $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: 'quantity=' + quantity + '&id=' + variant_id
        }).done(function(data, textStatus, jqXHR) {
          callback(true);
          _this.renderOther();
          return _this.add_locked = false;
        }).fail(function(jqXHR, textStatus) {
          callback(false, jqXHR.responseJSON.description);
          return _this.add_locked = false;
        });
      }
    };

    FrameworkCart.prototype.updateTotals = function() {
      var _this;
      _this = this;
      return $.ajax({
        type: "POST",
        url: "/cart.js",
        dataType: "json"
      }).done(function(data, textStatus, jqXHR) {
        var cart, cart_total, item, j, len1, ref;
        if (textStatus === 'success') {
          cart = data;
          cart_total = {};
          cart_total.quantity = 0;
          cart_total.price = 0;
          ref = cart.items;
          for (j = 0, len1 = ref.length; j < len1; j++) {
            item = ref[j];
            cart_total.quantity += item.quantity;
            cart_total.price += item.price * item.quantity;
          }
          _this.totals.count = cart_total.quantity;
          _this.totals.price = Currency.formatMoney(cart_total.price, theme.money_format);
          _this.render_trigger.find('.count').html(_this.totals.count);
          _this.render_trigger.find('.total-price').html(_this.totals.price);
          _this.table_content.find('.total').html(_this.totals.price);
          $('.layout--header .layout--off-canvas--trigger.right').html(_this.totals.count);
          $('.layout--header .cart-link .count').html('(' + _this.totals.count + ')');
          if (_this.totals.count > 0) {
            _this.render_trigger.css('display', 'inline-block');
            $('.layout--header .cart-link .count').css('display', 'inline');
            $('.layout--header .cart-count').css('display', 'inline-block');
          } else {
            _this.render_trigger.hide();
            $('.layout--header .cart-link .count').hide();
          }
          if (theme.currency_switcher_enabled) {
            _this.convertCurrency(_this.render_trigger.find('.total-price'));
            return _this.convertCurrency(_this.table_content.find('.total'));
          }
        } else {
          return console.log('cart - update totals item status - ' + textStatus);
        }
      }).fail(function(jqXHR, textStatus) {
        return console.log("cart - updating totals failed");
      });
    };

    FrameworkCart.prototype.removeItemListeners = function() {
      var _this;
      _this = this;
      return this.table_content.find('a.remove').on('click.LayoutCartModal', function() {
        var variant_id;
        variant_id = $(this).closest('.variant-id').data('variant-id');
        _this.removeItem(variant_id);
        if ($(this).closest('form').find('.variant-id').length === 1) {
          _this.container.addClass('no-items');
          $(window).trigger('resize.FrameworkModal');
        } else {
          $(this).closest('.variant-id').remove();
        }
        _this.updateTotals();
        return false;
      });
    };

    FrameworkCart.prototype.removeItem = function(variant_id) {
      return this.minusQuantity(variant_id, 0);
    };

    FrameworkCart.prototype.openOffCanvasListener = function() {
      return $('.layout--off-canvas--cart--open-trigger').on('click', function() {
        $('.layout--off-canvas--sidebar.right').trigger('open');
        return false;
      });
    };

    FrameworkCart.prototype.openModalListener = function() {
      return $('.fw--cart-modal--trigger-render').on('click', function() {
        $('.cart-link .modal--link').trigger('click');
        return false;
      });
    };

    FrameworkCart.prototype.convertCurrency = function(elems) {
      if (theme.currency_switcher_enabled) {
        return Currency.convertAll(Currency.shop_currency, Currency.currentCurrency, elems, null, true);
      } else {
        return false;
      }
    };

    return FrameworkCart;

  })();

  theme.classes.FrameworkLoadingAnimation = (function() {
    function FrameworkLoadingAnimation(root) {
      var _this;
      this.root = root;
      _this = this;
      if (_this.root.hasClass('tiny')) {
        _this.root.spin('tiny');
      } else {
        _this.root.spin('small');
      }
    }

    return FrameworkLoadingAnimation;

  })();

  theme.classes.FrameworkMediaQueries = (function() {
    function FrameworkMediaQueries() {
      this.screenSizeListener = bind(this.screenSizeListener, this);
      this.getScreenSize = bind(this.getScreenSize, this);
      this.medium_screen = 768;
      this.large_screen = 1024;
      this.current_window = null;
      this.getScreenSize();
      this.screenSizeListener();
    }

    FrameworkMediaQueries.prototype.getScreenSize = function() {
      var _this;
      _this = this;
      if ($("html").hasClass("lt-ie9")) {
        $.event.trigger("largeWindow");
        return _this.current_window = 'large';
      } else if (window.matchMedia('only screen and (min-width: ' + _this.large_screen + 'px)').matches) {
        if (_this.current_window !== 'large') {
          $.event.trigger("largeWindow");
          return _this.current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + _this.medium_screen + 'px)').matches) {
        if (_this.current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return _this.current_window = 'medium';
        }
      } else {
        if (_this.current_window !== 'small') {
          $.event.trigger("smallWindow");
          return _this.current_window = 'small';
        }
      }
    };

    FrameworkMediaQueries.prototype.screenSizeListener = function() {
      var _this;
      _this = this;
      return $(window).resize(function() {
        return _this.getScreenSize();
      });
    };

    return FrameworkMediaQueries;

  })();

  theme.classes.FrameworkModal = (function() {
    function FrameworkModal(container1) {
      var _this;
      this.container = container1;
      _this = this;
      _this.fullscreen = _this.container.data('modal--fullscreen') ? true : false;
      if (_this.container.data('modal--custom-close')) {
        _this.custom_close_button = _this.container.data('modal--custom-close');
      } else {
        _this.custom_close_button = '';
      }
      _this.view = _this.container.data('modal--view');
      _this.links = _this.container.find('.modal--link');
      _this.content = _this.container.find('.modal--content');
      _this.spinner = null;
      _this.window = _this.createModalWindow();
      _this.spinner = _this.window.find('.fw--loading_animation');
      _this.spinner.spin('large', '#fff');
      _this.window_container = _this.window.find('.modal--container');
      _this.mask = _this.window.find('.modal--mask');
      _this.close_button = _this.window.find('.modal--close');
      _this.next_button = _this.window.find('.modal--next');
      _this.prev_button = _this.window.find('.modal--prev');
      _this.slider = null;
      _this.slides = null;
      _this.main_content_window = $('.fw--off-canvas--main-content');
      _this.openListeners();
      _this.modal_state = 'closed';
      _this.nav_lock = false;
    }

    FrameworkModal.prototype.createModalWindow = function() {
      var _this, window, window_html;
      _this = this;
      window = null;
      if ($('.modal--window').length) {
        window = $('.modal--window');
      } else {
        window_html = '<div class="modal--window"> <div class="modal--mask"></div> <div class="fw--loading_animation" data-js-class="FrameworkLoadingAnimation"></div> <div class="modal--container"></div> <button class="modal--close">' + theme.utils.addSymbol('cross') + '</button> <button class="modal--prev">' + theme.utils.addSymbol('chevron-left') + '</button> <button class="modal--next">' + theme.utils.addSymbol('chevron-right') + '</button> </div>';
        window = $(window_html).appendTo('body');
      }
      return window;
    };

    FrameworkModal.prototype.openListeners = function() {
      var _this;
      _this = this;
      return _this.links.on('keypress.FrameworkModal, click.FrameworkModal, quick-open', function(e) {
        var clicked_item;
        if (e.type === 'keypress' && theme.utils.a11yClick(e) === false) {
          return false;
        }
        clicked_item = $(this);
        _this.links.each(function(index) {
          if ($(this).is(clicked_item)) {
            if (e.type === 'quick-open') {
              return _this.open(index, true);
            } else {
              return _this.open(index);
            }
          }
        });
        return false;
      });
    };

    FrameworkModal.prototype.open = function(index, quick_open) {
      var _this, scrolled_position;
      if (quick_open == null) {
        quick_open = false;
      }
      _this = this;
      if (_this.modal_state === 'closed') {
        _this.modal_state = 'opened';
        $('html').addClass('modal-open');
        _this.window.attr('data-modal--fullscreen', _this.fullscreen);
        _this.window.attr('data-modal--custom-close', _this.custom_close_button);
        _this.window.attr('data-modal--view', _this.view);
        _this.closeListeners();
        _this.positionListeners();
        scrolled_position = $(window).scrollTop();
        _this.main_content_window.css({
          position: 'fixed',
          top: -scrolled_position
        });
        _this.moveContentToWindow();
        if (_this.slides.length > 1) {
          _this.next_button.show();
          _this.prev_button.show();
          _this.prevListeners();
          _this.nextListeners();
        }
        _this.window.show();
        _this.window_container.show();
        _this.renderVideo(_this.slides.eq(index));
        if (quick_open) {
          _this.slides.eq(index).addClass('active');
          return _this.position();
        } else {
          _this.mask.fadeIn();
          return _this.loadModal(_this.slides.eq(index), function() {
            return setTimeout(function() {
              return _this.window_container.find('input[type="text"]').focus();
            }, 0);
          });
        }
      }
    };

    FrameworkModal.prototype.moveContentToWindow = function(index) {
      var _this, content;
      _this = this;
      content = _this.container.find('.modal--content');
      _this.window_container.append(content);
      return _this.slides = _this.window_container.find('.modal--content');
    };

    FrameworkModal.prototype.detectImageSlide = function(slide) {
      var _this;
      _this = this;
      if (slide.children().length === 1 && slide.children().first().is('img')) {
        slide.addClass('type--image');
        return slide.find('img').css({
          'max-height': $(window).height()
        });
      }
    };

    FrameworkModal.prototype.renderVideo = function(slide) {
      var _this, id, iframe, src_url, type, video;
      _this = this;
      video = slide.find('.responsive-video').first();
      src_url = video.data('video');
      type = _this.extractVideoType(src_url);
      id = _this.extractVideoId(src_url, type);
      iframe = _this.createIframe(type, id);
      if (type === 'vimeo') {
        video.addClass('vimeo');
      }
      if (type === 'kickstarter') {
        video.addClass('kickstarter');
      }
      return video.append(iframe);
    };

    FrameworkModal.prototype.extractVideoType = function(src_url) {
      var _this, matches, re;
      _this = this;
      re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(src_url);
      if (matches) {
        return 'youtube';
      }
      re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
      matches = re.exec(src_url);
      if (matches) {
        return 'vimeo';
      }
      re = /^.*(kickstarter)\.com/g;
      matches = re.exec(src_url);
      if (matches) {
        return 'kickstarter';
      }
      return false;
    };

    FrameworkModal.prototype.extractVideoId = function(src_url, type) {
      var _this, match, regExp;
      _this = this;
      if (type === 'youtube') {
        regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = src_url.match(regExp);
        if (match) {
          return match[2];
        }
      } else if (type === "kickstarter") {
        regExp = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/;
        match = src_url.match(regExp);
        if (match) {
          return match[1];
        }
      }
    };

    FrameworkModal.prototype.createIframe = function(type, id) {
      var _this;
      _this = this;
      if (type === "youtube") {
        return '<iframe  src="//www.youtube.com/embed/' + id + '?autoplay=1" frameborder="0" allowfullwidth></iframe>';
      } else if (type === "vimeo") {
        return '<iframe src="//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      } else if (type === "kickstarter") {
        return '<iframe src="//www.kickstarter.com/projects/' + id + '/widget/video.html" frameborder="0" webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>';
      }
    };

    FrameworkModal.prototype.removeVideos = function() {
      var _this;
      _this = this;
      return _this.slides.find('.responsive-video').each(function() {
        if ($(this).data('video')) {
          return $(this).find('iframe').remove();
        }
      });
    };

    FrameworkModal.prototype.loadModal = function(modal, callback) {
      var _this;
      _this = this;
      _this.spinner.show();
      return setTimeout(function() {
        return modal.imagesLoaded(function() {
          _this.spinner.hide();
          modal.addClass('active');
          _this.position();
          if (callback) {
            callback();
          }
          return _this.nav_lock = false;
        });
      }, 300);
    };

    FrameworkModal.prototype.position = function() {
      var _this, active_modal, entire_modal_height, modal_height, modal_width;
      _this = this;
      if (_this.window_container != null) {
        active_modal = _this.content.filter('.active');
        _this.window_container.attr('style', '');
        _this.positionVideoColumns(active_modal);
        _this.detectImageSlide(active_modal);
        _this.window.removeClass('fixed');
        modal_height = active_modal.outerHeight();
        modal_width = active_modal.outerWidth();
        entire_modal_height = modal_height + parseInt(_this.window.css('padding-top')) + parseInt(_this.window.css('padding-bottom'));
        if (_this.fullscreen) {
          return;
        }
        if (active_modal.hasClass('type--image')) {
          entire_modal_height = modal_height;
        }
        if ($(window).height() >= entire_modal_height) {
          return _this.window.addClass('fixed');
        } else {
          $("html, body").animate({
            scrollTop: 0
          }, '0');
          $('body,html').on('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal', function(e) {
            if (e.which > 0 || e.type === "mousewheel" || e.type === "touchmove") {
              return $("html,body").stop();
            }
          });
          return _this.window.removeClass('fixed');
        }
      }
    };

    FrameworkModal.prototype.positionVideoColumns = function(modal) {
      var _this, column_one, column_two, height_one, height_two;
      _this = this;
      if (modal.find('.responsive-video').length > 0) {
        column_one = modal.find('.fw--blocks > div').eq(0);
        column_two = modal.find('.fw--blocks > div').eq(1);
        column_one.css({
          width: ''
        });
        column_two.css({
          width: ''
        });
        height_one = column_one.outerHeight();
        height_two = column_two.outerHeight();
        if (height_one < height_two) {
          column_one.css({
            width: '100%'
          });
          return column_two.css({
            width: '100%'
          });
        }
      }
    };

    FrameworkModal.prototype.positionListeners = function() {
      var _this;
      _this = this;
      return $(window).on('resize.FrameworkModal', function() {
        return _this.position();
      });
    };

    FrameworkModal.prototype.nextListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 39) {
          return _this.next();
        }
      });
      return _this.next_button.on('click.FrameworkModal', function() {
        return _this.next();
      });
    };

    FrameworkModal.prototype.next = function() {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter('.active').index();
        _this.slides.removeClass('active');
        _this.removeVideos();
        if ((index + 1) === _this.slides.length) {
          active_slide = _this.slides.eq(0);
        } else {
          active_slide = _this.slides.eq(index + 1);
        }
        _this.renderVideo(active_slide);
        return _this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.prevListeners = function() {
      var _this;
      _this = this;
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 37) {
          return _this.prev();
        }
      });
      return _this.prev_button.on('click.FrameworkModal', function() {
        return _this.prev();
      });
    };

    FrameworkModal.prototype.prev = function() {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter('.active').index();
        _this.slides.removeClass('active');
        _this.removeVideos();
        if (index === 0) {
          active_slide = _this.slides.eq(_this.slides.length - 1);
        } else {
          active_slide = _this.slides.eq(index - 1);
        }
        _this.renderVideo(active_slide);
        return _this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.closeListeners = function() {
      var _this;
      _this = this;
      _this.container.on('quick-close', function() {
        return _this.close(true);
      });
      $(document).on('keydown.FrameworkModal', function(e) {
        if (e.keyCode === 27) {
          return _this.close();
        }
      });
      _this.mask.on('click.FrameworkModal', function() {
        return _this.close();
      });
      _this.window_container.on('click.FrameworkModal', function() {
        return _this.close();
      });
      _this.content.on('click.FrameworkModal', function(e) {
        return e.stopPropagation();
      });
      return _this.close_button.on('click.FrameworkModal', function() {
        return _this.close();
      });
    };

    FrameworkModal.prototype.close = function(quick_close) {
      var _this, scrolled_position;
      if (quick_close == null) {
        quick_close = false;
      }
      _this = this;
      $('html').removeClass('modal-open');
      if (!$('.fw--loading_animation').is(':visible')) {
        _this = this;
        scrolled_position = parseInt(_this.main_content_window.css('top')) * -1;
        _this.container.trigger('modalClosed');
        _this.main_content_window.css({
          top: '0',
          position: 'relative'
        });
        $(window).scrollTop(scrolled_position);
        _this.putBackContent();
        _this.next_button.hide();
        _this.prev_button.hide();
        _this.window.hide();
        if (quick_close) {
          _this.mask.hide();
          this.window_container.empty();
          _this.modal_state = 'closed';
        } else {
          _this.mask.fadeOut(function() {
            _this.window_container.empty();
            return _this.modal_state = 'closed';
          });
        }
        return _this.removeListeners();
      }
    };

    FrameworkModal.prototype.putBackContent = function() {
      var _this;
      _this = this;
      _this.removeVideos();
      return _this.slides.removeClass('active').appendTo(_this.container);
    };

    FrameworkModal.prototype.removeListeners = function() {
      var _this;
      _this = this;
      $(document).off('keydown.FrameworkModal');
      $(window).off('resize.FrameworkModal');
      $('body,html').off('DOMMouseScroll.FrameworkModal mousewheel.FrameworkModal touchmove.FrameworkModal');
      _this.next_button.off('click.FrameworkModal');
      _this.prev_button.off('click.FrameworkModal');
      _this.close_button.off('click.FrameworkModal');
      _this.mask.off('click.FrameworkModal');
      return _this.window_container.off('click.FrameworkModal');
    };

    return FrameworkModal;

  })();

  theme.classes.FrameworkOffCanvas = (function() {
    function FrameworkOffCanvas() {
      this.closeRight = bind(this.closeRight, this);
      this.closeLeft = bind(this.closeLeft, this);
      this.closeListeners = bind(this.closeListeners, this);
      this.fadeInOverlay = bind(this.fadeInOverlay, this);
      this.openRight = bind(this.openRight, this);
      this.openLeft = bind(this.openLeft, this);
      this.openListeners = bind(this.openListeners, this);
      this.viewPortHeightListener = bind(this.viewPortHeightListener, this);
      this.setViewPortHeight = bind(this.setViewPortHeight, this);
      this.toggleListeners = bind(this.toggleListeners, this);
      this.viewport = $('.fw--off-canvas--viewport');
      this.left_sidebar = $('.fw--off-canvas--sidebar.left');
      this.right_sidebar = $('.fw--off-canvas--sidebar.right');
      this.main_content = $('.fw--off-canvas--main-content');
      this.overlay = this.main_content.find('> .overlay');
      this.triggers = $('.fw--off-canvas--trigger');
      this.state = 'closed';
      this.setViewPortHeight();
      this.viewPortHeightListener();
      this.openListeners();
      this.closeListeners();
    }

    FrameworkOffCanvas.prototype.toggleListeners = function() {
      var _this;
      _this = this;
      return this.sub_menu_links.on('click.LayoutMainMenu', function() {
        if (_this.state === 'closed') {
          _this.open($(this));
        } else if ($(this).hasClass('open')) {
          _this.close($(this));
        } else {
          _this.changeTo($(this));
        }
        return false;
      });
    };

    FrameworkOffCanvas.prototype.setViewPortHeight = function() {
      var _this;
      _this = this;
      return _this.viewport.css({
        'min-height': $(window).height()
      });
    };

    FrameworkOffCanvas.prototype.viewPortHeightListener = function() {
      var _this;
      _this = this;
      return $(window).resize(function() {
        return _this.setViewPortHeight();
      });
    };

    FrameworkOffCanvas.prototype.openListeners = function() {
      var _this;
      _this = this;
      this.triggers.on('click', function() {
        if ($(this).hasClass('open left')) {
          return _this.openLeft();
        } else if ($(this).hasClass('open right')) {
          return _this.openRight();
        }
      });
      return this.right_sidebar.on('open', function() {
        return _this.openRight();
      });
    };

    FrameworkOffCanvas.prototype.openLeft = function() {
      var _this;
      _this = this;
      this.state = 'left-open';
      _this.main_content.css({
        position: 'fixed',
        top: -($(window).scrollTop())
      });
      this.left_sidebar.velocity({
        translateX: [0, '-100%']
      }, {
        complete: function() {
          return _this.left_sidebar.css({
            position: 'relative',
            height: $(window).height()
          });
        }
      });
      this.main_content.velocity({
        translateX: ['90%', 0]
      });
      return this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.openRight = function() {
      var _this;
      _this = this;
      this.state = 'right-open';
      _this.main_content.css({
        position: 'fixed',
        top: -($(window).scrollTop())
      });
      this.right_sidebar.velocity({
        translateX: [0, '100%']
      }, {
        complete: function() {
          return _this.right_sidebar.css({
            position: 'relative',
            left: '10%'
          });
        }
      });
      this.main_content.velocity({
        translateX: ['-90%', 0]
      });
      return this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.fadeInOverlay = function() {
      this.overlay.show();
      return this.overlay.velocity({
        opacity: '0.5'
      });
    };

    FrameworkOffCanvas.prototype.closeListeners = function() {
      var _this;
      _this = this;
      return this.overlay.on('click', function() {
        if (_this.state === 'left-open') {
          return _this.closeLeft();
        } else if (_this.state === 'right-open') {
          return _this.closeRight();
        }
      });
    };

    FrameworkOffCanvas.prototype.closeLeft = function() {
      var _this, scrolled_position;
      _this = this;
      this.state = 'closed';
      scrolled_position = parseInt(this.main_content.css('top')) * -1;
      this.left_sidebar.css({
        position: 'absolute'
      });
      this.main_content.css({
        position: 'relative',
        top: 'initial'
      });
      $(window).scrollTop(scrolled_position);
      this.left_sidebar.velocity({
        translateX: ['-100%', 0]
      });
      this.main_content.velocity({
        translateX: [0, '90%']
      });
      return this.overlay.velocity('fadeOut');
    };

    FrameworkOffCanvas.prototype.closeRight = function() {
      var _this, scrolled_position;
      _this = this;
      this.state = 'closed';
      scrolled_position = parseInt(this.main_content.css('top')) * -1;
      this.right_sidebar.css({
        position: 'absolute',
        left: 'auto'
      });
      this.main_content.css({
        position: 'relative',
        top: 'initial'
      });
      $(window).scrollTop(scrolled_position);
      this.right_sidebar.velocity({
        translateX: ['100%', 0]
      });
      this.main_content.velocity({
        translateX: [0, '-90%']
      });
      return this.overlay.velocity('fadeOut');
    };

    return FrameworkOffCanvas;

  })();

  theme.classes.FrameworkSearch = (function() {
    function FrameworkSearch(container1) {
      this.container = container1;
      this.linkRows = bind(this.linkRows, this);
      this.closeListeners = bind(this.closeListeners, this);
      this.hideResults = bind(this.hideResults, this);
      this.focusListener = bind(this.focusListener, this);
      this.getResults = bind(this.getResults, this);
      this.focusModalAlways = bind(this.focusModalAlways, this);
      this.listenForKeyEntered = bind(this.listenForKeyEntered, this);
      this.loadSpinners = bind(this.loadSpinners, this);
      this.toggle_link = this.container.find('a.toggle');
      this.form = this.container.find('form');
      this.text_box = this.form.find('input[name="q"]');
      this.loading = this.container.find('> .feedback .loading');
      this.no_results = this.container.find('> .feedback .no-results');
      this.results = this.container.find('> .results');
      this.view = this.container.data('view');
      this.max_results = 12;
      this.ajax_request = null;
      this.search_term = null;
      this.search_url = null;
      this.close_results_timer = null;
      this.typing_timer = null;
      this.focusModalAlways();
      this.listenForKeyEntered();
      this.loadSpinners();
    }

    FrameworkSearch.prototype.loadSpinners = function() {
      var spinner;
      spinner = this.loading.find('> .animation');
      if (spinner.hasClass('tiny')) {
        return spinner.spin('tiny');
      } else {
        return spinner.spin('small');
      }
    };

    FrameworkSearch.prototype.listenForKeyEntered = function() {
      var _this;
      _this = this;
      return this.text_box.attr("autocomplete", "off").on("keyup paste", function() {
        var term;
        clearTimeout(_this.typing_timer);
        term = $(this).val();
        _this.results.hide();
        _this.loading.show();
        _this.no_results.hide();
        return _this.typing_timer = setTimeout(function() {
          _this.search_url = "/search?type=product&q=" + term;
          if (term.length > 1) {
            return _this.getResults(term);
          } else {
            _this.results.empty();
            _this.hideResults();
            return _this.loading.hide();
          }
        }, 300);
      });
    };

    FrameworkSearch.prototype.focusModalAlways = function() {
      var _this;
      _this = this;
      if (this.view === 'grid') {
        return this.container.on('click', function() {
          return _this.text_box.focus();
        });
      }
    };

    FrameworkSearch.prototype.getResults = function(term) {
      var _this;
      _this = this;
      if (this.ajax_request) {
        this.ajax_request.abort();
      }
      this.results.empty();
      this.ajax_request = $.getJSON(this.search_url + "&view=json", function(data) {
        if (data.results_count === 0) {
          _this.close_results_timer = setTimeout(function() {
            _this.hideResults();
            _this.no_results.show();
            return _this.loading.hide();
          }, 300);
        } else {
          clearTimeout(_this.close_results_timer);
          _this.loading.hide();
          _this.no_results.hide();
          _this.results.show();
          _this.results.stop(true, true).fadeIn(0);
          $.each(data.results, function(index, item) {
            var row;
            if (index >= _this.max_results) {
              return;
            }
            if (_this.view === 'grid') {
              row = "<div class=\"partial--product item column width--medium-4 width--large-3\" data-link=\"" + item.url + "\">";
              row += '<a href="' + item.url + '">';
              row += '<div class="image-wrapper"><img src="' + item.image_medium + '" /></div>';
              row += '<div class="caption"><p class="title">' + item.title + '</p></div>';
              row += '</a></div>';
              row = $(row);
            } else if (_this.view === 'list') {
              row = $('<a class="item" href="' + item.url + '"><span class="image-wrapper"><img src="' + item.image_medium + '" /></span><span class="title">' + item.title + '</span></a>');
            }
            _this.results.append(row);
          });
          $.event.trigger("ie8ClearingFix");
          if (data.results_count > _this.max_results) {
            _this.results.append('<div class="row view-more"><a href="' + _this.search_url + '">' + theme.translations.general_search_see_all_results + ' ("' + data.results_count + '")</a></div>');
          }
          _this.closeListeners();
        }
      }).fail(function() {
        return console.log("error retrieving search.json results");
      });
    };

    FrameworkSearch.prototype.focusListener = function() {
      var _this;
      _this = this;
      return this.text_box.on('focus', function() {
        return _this.results.show();
      });
    };

    FrameworkSearch.prototype.hideResults = function() {
      this.results.fadeOut(0);
      return this.focusListener();
    };

    FrameworkSearch.prototype.closeListeners = function() {
      var _this;
      _this = this;
      if (this.view !== "grid") {
        this.linkRows();
        $(document).on('click', function(event) {
          if (!$(event.target).closest('.partial--searchbar').length) {
            return _this.hideResults();
          }
        });
        return $(document).keydown(function(e) {
          if (e.keyCode === 27) {
            return _this.text_box.trigger('blur');
          }
        });
      }
    };

    FrameworkSearch.prototype.linkRows = function() {
      var _this;
      _this = this;
      return this.results.find("td").on('click', function() {
        var link;
        link = $(this).parent().attr('data-link');
        if (link.length) {
          return window.location = link;
        }
      });
    };

    return FrameworkSearch;

  })();

  theme.classes.Sections = (function() {
    function Sections() {
      this.unload = bind(this.unload, this);
      this.deselectBlock = bind(this.deselectBlock, this);
      this.selectBlock = bind(this.selectBlock, this);
      this.deselectSection = bind(this.deselectSection, this);
      this.selectSection = bind(this.selectSection, this);
      this.load = bind(this.load, this);
      this.getActiveBlock = bind(this.getActiveBlock, this);
      this.getActiveSection = bind(this.getActiveSection, this);
      this.listeners = bind(this.listeners, this);
      var _this;
      _this = this;
      _this.listeners();
    }

    Sections.prototype.listeners = function() {
      var _this;
      _this = this;
      _this.load();
      _this.unload();
      _this.selectSection();
      _this.deselectSection();
      _this.selectBlock();
      return _this.deselectBlock();
    };

    Sections.prototype.getActiveSection = function(evt) {
      var _this, active_section;
      _this = this;
      active_section = $(evt.target).find('[data-section-id]');
      return active_section;
    };

    Sections.prototype.getActiveBlock = function(evt) {
      var _this, active_block;
      _this = this;
      active_block = $(evt.target);
      return active_block;
    };

    Sections.prototype.load = function(evt) {
      var _this;
      _this = this;
      return $(document).on('shopify:section:load', function(evt) {
        var active_section;
        theme.utils.loadJsClasses();
        active_section = _this.getActiveSection(evt);
        active_section.triggerHandler("theme:section:load");
        return active_section.find('[data-js-class]').each(function() {
          return $(this).triggerHandler("theme:section:load");
        });
      });
    };

    Sections.prototype.selectSection = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:section:select', function(evt) {
        var active_section;
        active_section = _this.getActiveSection(evt);
        return active_section.triggerHandler("theme:section:select");
      });
    };

    Sections.prototype.deselectSection = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:section:deselect', function(evt) {
        var active_section;
        active_section = _this.getActiveSection(evt);
        return active_section.triggerHandler('theme:section:deselect');
      });
    };

    Sections.prototype.selectBlock = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:block:select', function(evt) {
        var active_block;
        active_block = _this.getActiveBlock(evt);
        return active_block.triggerHandler('theme:block:select');
      });
    };

    Sections.prototype.deselectBlock = function() {
      var _this;
      _this = this;
      return $(document).on('shopify:block:deselect', function(evt) {
        var active_block;
        active_block = _this.getActiveBlock(evt);
        return active_block.triggerHandler('theme:block:deselect');
      });
    };

    Sections.prototype.unload = function(evt) {
      var _this;
      _this = this;
      return $(document).on('shopify:section:unload', function(evt) {
        var active_section;
        active_section = _this.getActiveSection(evt);
        active_section.triggerHandler("theme:section:unload");
        return active_section.find('[data-js-loaded="true"]').each(function() {
          return $(this).triggerHandler("theme:section:unload");
        });
      });
    };

    return Sections;

  })();

  theme.classes.FrameworkSlider = (function() {
    function FrameworkSlider(container1) {
      this.container = container1;
      this.eventListeners = bind(this.eventListeners, this);
      this.alignPlayButton = bind(this.alignPlayButton, this);
      this.updateContextMenu = bind(this.updateContextMenu, this);
      this.autoplay = bind(this.autoplay, this);
      this.formatPaginationNumbers = bind(this.formatPaginationNumbers, this);
      this.getActiveIndex = bind(this.getActiveIndex, this);
      this.createSlider = bind(this.createSlider, this);
      this.autoplay_enabled = this.container.data('autoplay') ? true : false;
      this.navigation = this.container.data('navigation') ? true : false;
      this.pagination_numbers = this.container.data('pagination-numbers') ? true : false;
      this.autoplay_frequency = 3000;
      this.slide_length = this.container.children().length;
      this.active_index = 0;
      this.news_panel = this.container.data('news-panel') ? true : false;
      this.createSlider();
      this.eventListeners();
      this.owl = this.container.data('owlCarousel');
    }

    FrameworkSlider.prototype.createSlider = function() {
      var _this, slider;
      _this = this;
      slider = this.container.owlCarousel({
        singleItem: true,
        navigation: _this.navigation,
        navigationText: false,
        pagination: _this.container.data('pagination') ? true : false,
        paginationNumbers: _this.pagination_numbers,
        scrollPerPageNav: true,
        slideSpeed: 800,
        autoHeight: false,
        autoPlay: _this.autoplay(),
        afterInit: function() {},
        afterAction: function() {
          _this.alignPlayButton();
          _this.active_index = _this.getActiveIndex();
          _this.updateContextMenu(_this.active_index);
          return _this.formatPaginationNumbers();
        }
      });
      if (_this.navigation) {
        slider.find('.owl-prev').html(theme.utils.addSymbol('chevron-left'));
        slider.find('.owl-next').html(theme.utils.addSymbol('chevron-right'));
      }
      return slider;
    };

    FrameworkSlider.prototype.getActiveIndex = function() {
      return this.container.find('.owl-pagination .owl-page.active').index();
    };

    FrameworkSlider.prototype.formatPaginationNumbers = function() {
      return this.container.find('.owl-page.active .owl-numbers').text((this.active_index + 1) + "/" + this.slide_length);
    };

    FrameworkSlider.prototype.autoplay = function() {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FrameworkSlider.prototype.updateContextMenu = function(index) {
      var context_navigation, type_class;
      if (this.news_panel) {
        type_class = '.' + this.container.find('.slide').eq(index).data('feed-type');
        context_navigation = this.container.closest('.template--index--news').find('.context-navigation');
        context_navigation.find('.item').hide();
        return context_navigation.find(type_class).show();
      }
    };

    FrameworkSlider.prototype.alignPlayButton = function() {
      var play_button, slide;
      slide = this.container.find('.owl-item').eq(this.active_index);
      play_button = slide.find('.play-button');
      if (play_button.length === 0) {
        return;
      }
      play_button.css('visibility', 'hidden');
      if (PAGE.hasClass('transparent-menu') && $('.main-header').css('position') === 'absolute') {
        slide.find('img').first().imagesLoaded(function() {
          var play_button_height, slide_height, video_offset;
          slide_height = slide.outerHeight();
          play_button_height = play_button.outerHeight();
          video_offset = (slide_height - play_button_height) / 2;
          return play_button.css({
            'margin-top': 0,
            'top': video_offset
          });
        });
      } else {
        play_button.css({
          'margin-top': '-40px',
          'top': '50%'
        });
      }
      return play_button.css('visibility', 'visible');
    };

    FrameworkSlider.prototype.eventListeners = function() {
      var _this;
      _this = this;
      this.container.find(".play-button").on('click', function() {
        var video_modal;
        video_modal = new VideoModal($(this).closest('.video'));
        video_modal.open();
        _this.owl.stop();
        return false;
      });
      return this.container.find('.owl-pagination .owl-page, .skip-to-next').on('click', function() {
        _this.owl.next();
        return false;
      });
    };

    return FrameworkSlider;

  })();

  theme.classes.FrameworkStickyColumn = (function() {
    function FrameworkStickyColumn(container1, column_a, column_b, mq) {
      this.container = container1;
      this.column_a = column_a;
      this.column_b = column_b;
      this.mq = mq;
      this.Listeners = bind(this.Listeners, this);
      this.setColumnPosition = bind(this.setColumnPosition, this);
      this.getAlignment = bind(this.getAlignment, this);
      this.getState = bind(this.getState, this);
      this.resetLargerColumn = bind(this.resetLargerColumn, this);
      this.getSmallerColumn = bind(this.getSmallerColumn, this);
      this.heightsHaveChanged = bind(this.heightsHaveChanged, this);
      this.setHeights = bind(this.setHeights, this);
      this.loadColumns = bind(this.loadColumns, this);
      if (Modernizr.touch) {
        return false;
      }
      this.current_state = 'auto';
      this.column_a_height = 0;
      this.column_b_height = 0;
      this.loadColumns();
    }

    FrameworkStickyColumn.prototype.loadColumns = function() {
      var _this;
      _this = this;
      return _this.container.imagesLoaded(function() {
        _this.Listeners();
        return _this.setColumnPosition();
      });
    };

    FrameworkStickyColumn.prototype.setHeights = function() {
      this.column_a_height = this.column_a.outerHeight();
      return this.column_b_height = this.column_b.outerHeight();
    };

    FrameworkStickyColumn.prototype.heightsHaveChanged = function() {
      if (this.column_a.outerHeight() !== this.column_a_height) {
        this.setHeights();
        return true;
      }
      if (this.column_b.outerHeight() !== this.column_b_height) {
        this.setHeights();
        return true;
      }
      return false;
    };

    FrameworkStickyColumn.prototype.getSmallerColumn = function() {
      if (this.column_a_height < this.column_b_height) {
        return this.column_a;
      } else {
        return this.column_b;
      }
    };

    FrameworkStickyColumn.prototype.resetLargerColumn = function() {
      if (this.column_a_height > this.column_b_height) {
        return this.column_a.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      } else {
        return this.column_b.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      }
    };

    FrameworkStickyColumn.prototype.getState = function(scroll_pos, window_height, column) {
      var column_height, height_for_bottom, overflowing_column, state;
      state = 'auto';
      if (this.mq.current_window === 'small') {
        return 'auto';
      }
      column_height = column.outerHeight();
      if (window_height > column_height) {
        overflowing_column = true;
      }
      if (scroll_pos < this.container.offset().top) {
        state = 'auto';
      }
      if (overflowing_column) {
        height_for_bottom = column_height;
      } else {
        height_for_bottom = window_height;
      }
      if ((scroll_pos + height_for_bottom) > (this.container.offset().top + this.container.outerHeight())) {
        state = 'absolute-bottom';
      } else if (scroll_pos > this.container.offset().top && overflowing_column) {
        state = 'fixed-top';
      } else if (window_height < column_height && (scroll_pos + window_height) > (this.container.offset().top + column.outerHeight())) {
        state = 'fixed-bottom';
      }
      return state;
    };

    FrameworkStickyColumn.prototype.getAlignment = function(column) {
      if (column.hasClass('column-a')) {
        return 'left';
      } else if (column.hasClass('column-b')) {
        return 'right';
      }
    };

    FrameworkStickyColumn.prototype.setColumnPosition = function() {
      var _this, align, column, state;
      _this = this;
      _this.setHeights();
      column = _this.getSmallerColumn();
      state = _this.getState($(window).scrollTop(), $(window).height(), column);
      align = _this.getAlignment(column);
      if (state === 'auto' && this.current_state !== 'auto') {
        this.current_state = 'auto';
        column.css({
          'position': 'relative',
          'top': 'auto',
          'bottom': 'auto'
        });
      } else if (state === 'fixed-bottom' && this.current_state !== 'fixed-bottom') {
        this.current_state = 'fixed-bottom';
        column.css({
          'position': 'fixed',
          'top': 'auto',
          'bottom': 0
        });
      } else if (state === 'fixed-top' && this.current_state !== 'fixed-top') {
        this.current_state = 'fixed-top';
        column.css({
          'position': 'fixed',
          'top': 0,
          'bottom': 'auto'
        });
      } else if (state === 'absolute-bottom' && this.current_state !== 'absolute-bottom') {
        this.current_state = 'absolute-bottom';
        column.css({
          'position': 'absolute',
          'top': 'auto',
          'bottom': 0
        });
      }
      if (align === 'right') {
        return column.css({
          'right': 0
        });
      }
    };

    FrameworkStickyColumn.prototype.Listeners = function() {
      var _this;
      _this = this;
      $(window).scroll(function() {
        return _this.setColumnPosition();
      });
      setInterval(function() {
        if (_this.heightsHaveChanged()) {
          _this.resetLargerColumn();
          return _this.setColumnPosition();
        }
      }, 250);
      return $(window).resize(function() {
        _this.resetLargerColumn();
        return _this.setColumnPosition();
      });
    };

    return FrameworkStickyColumn;

  })();

  Accordion = (function() {
    function Accordion() {
      $('.accordion.headings').each(function() {
        return $(this).add($(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
      });
      $('.accordion.headings li').wrapInner('<div class="trigger"></div>');
      $('.accordion.headings li .trigger').append('<div class="bg"></div>');
      $('.accordion-wrapper').each(function() {
        var accordion_content, accordion_heading;
        accordion_heading = $(this).find('.accordion.headings > li');
        accordion_content = $(this).find('.accordion.content > li');
        accordion_heading.first().addClass('active');
        accordion_content.each(function(index) {
          var content;
          content = $('<div class="content">' + $(this).html() + '</div>');
          return content.appendTo(accordion_heading.eq(index));
        });
        accordion_content.remove();
        $(this).find('.content').first().show();
        return $(this).find('.trigger').on("click", function() {
          var panels, this_panel;
          panels = $(this).closest(".accordion").find('.content');
          this_panel = $(this).closest("li").find(".content");
          panels.not(this_panel).slideUp(200);
          this_panel.slideDown(200, function() {
            if (general_scroll_to_active_item) {
              return $('html, body').animate({
                scrollTop: this_panel.offset().top - 100
              });
            }
          });
          $(this).closest(".accordion").find("li").removeClass("active");
          return $(this).closest("li").addClass("active");
        });
      });
    }

    return Accordion;

  })();

  Footer = (function() {
    function Footer(root) {
      var _this;
      this.root = root;
      this.stickyFooter = bind(this.stickyFooter, this);
      this.addListeners = bind(this.addListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    Footer.prototype.load = function() {
      var _this;
      _this = this;
      _this.addListeners();
      return _this.stickyFooter();
    };

    Footer.prototype.addListeners = function() {
      var _this;
      _this = this;
      return WINDOW.on('resize', function() {
        return _this.stickyFooter();
      });
    };

    Footer.prototype.stickyFooter = function() {
      var total_content_height;
      total_content_height = HEADER.outerHeight() + $('.main-content').outerHeight() + $('.main-footer').outerHeight();
      if (WINDOW.outerHeight() > total_content_height) {
        return $('.main-content').css({
          'min-height': WINDOW.outerHeight() - $('.main-header').outerHeight() - $('.main-footer').outerHeight()
        });
      }
    };

    return Footer;

  })();

  FullscreenSlider = (function() {
    function FullscreenSlider(slider_element) {
      this.eventListeners = bind(this.eventListeners, this);
      this.alignPlayButton = bind(this.alignPlayButton, this);
      this.alignCaption = bind(this.alignCaption, this);
      this.isFirstSlider = bind(this.isFirstSlider, this);
      this.getActiveIndex = bind(this.getActiveIndex, this);
      this.autoplay = bind(this.autoplay, this);
      this.createSlider = bind(this.createSlider, this);
      var slide_parent;
      this.el = slider_element;
      slide_parent = this.el.closest('.slider');
      this.autoplay_enabled = slide_parent.data('autoplay');
      if (slide_parent.find('.slide').length < 2) {
        this.autoplay_enabled = false;
      }
      this.autoplay_frequency = slide_parent.data('rotateFrequency');
      this.transition_style = slide_parent.data('transitionStyle');
      this.createSlider();
      this.owl = $(".owl-carousel").data('owlCarousel');
    }

    FullscreenSlider.prototype.createSlider = function() {
      var slider, slider_options;
      slider = this;
      slider_options = {
        singleItem: true,
        navigation: false,
        paginationNumbers: false,
        scrollPerPageNav: true,
        slideSpeed: 800,
        pagination: true,
        autoHeight: true,
        autoPlay: slider.autoplay(),
        afterInit: function() {
          return slider.eventListeners();
        },
        afterAction: function() {
          slider.alignCaption();
          return slider.alignPlayButton();
        }
      };
      if (this.transition_style !== 'default') {
        slider_options['transitionStyle'] = this.transition_style;
      }
      return slider.el.owlCarousel(slider_options);
    };

    FullscreenSlider.prototype.autoplay = function() {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FullscreenSlider.prototype.getActiveIndex = function() {
      return this.el.find('.owl-pagination .owl-page.active').index();
    };

    FullscreenSlider.prototype.isFirstSlider = function() {
      var current_section_id, first_section, first_section_id;
      first_section = $('.index-sections').children('div:first');
      first_section_id = first_section.find('.slider').data('sectionId');
      current_section_id = this.el.closest('.slider').data('sectionId');
      if (first_section.hasClass('section--slideshow')) {
        return current_section_id === first_section_id;
      }
      return false;
    };

    FullscreenSlider.prototype.alignCaption = function() {
      var caption, caption_height, caption_width, slide, slide_padding, top_offset;
      slide = this.el.find('.owl-item').eq(this.getActiveIndex());
      caption = slide.find('.caption');
      caption.css('visibility', 'hidden');
      caption_height = caption.outerHeight();
      caption_width = caption.outerWidth();
      slide_padding = 30;
      if (theme.utils.transparentMenuIsEnabled() && this.isFirstSlider() === true) {
        top_offset = $('.main-header').outerHeight();
      } else {
        top_offset = 0;
      }
      return slide.find('img').first().imagesLoaded(function() {
        var left_offset, middle_top, slide_height, slide_width;
        slide_height = slide.outerHeight();
        slide_width = slide.outerWidth();
        if (caption.hasClass('top')) {
          caption.css('top', top_offset + slide_padding);
        } else if (caption.hasClass('middle')) {
          middle_top = top_offset + (slide_height - top_offset - caption_height) / 2;
          caption.css('top', middle_top);
        }
        if (caption.hasClass('center')) {
          left_offset = (slide_width - caption_width) / 2;
          caption.css('left', left_offset);
        }
        return caption.css('visibility', 'visible');
      });
    };

    FullscreenSlider.prototype.alignPlayButton = function() {
      var play_button, slide;
      slide = this.el.find('.owl-item').eq(this.getActiveIndex());
      play_button = slide.find('.play-button');
      play_button.css('visibility', 'hidden');
      if (theme.utils.transparentMenuIsEnabled() && $('.main-header').css('position') === 'absolute') {
        slide.find('img').first().imagesLoaded(function() {
          var play_button_height, slide_height, video_offset;
          slide_height = slide.outerHeight();
          play_button_height = play_button.outerHeight();
          video_offset = (slide_height - play_button_height) / 2;
          return play_button.css({
            'margin-top': 0,
            'top': video_offset
          });
        });
      } else {
        play_button.css({
          'margin-top': '-40px',
          'top': '50%'
        });
      }
      return play_button.css('visibility', 'visible');
    };

    FullscreenSlider.prototype.eventListeners = function() {
      var slider;
      slider = this;
      this.el.find(".play-button").on('click', function() {
        var video_modal;
        video_modal = new VideoModal($(this).closest('.video'));
        video_modal.open();
        slider.owl.stop();
        return false;
      });
      this.el.find('.owl-pagination .owl-page').on('click', function() {
        return slider.owl.stop();
      });
      return DOC.on('header.transparentMenuIsUpdated', slider.alignCaption);
    };

    return FullscreenSlider;

  })();

  Header = (function() {
    function Header(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    Header.prototype.load = function() {
      var _this;
      _this = this;
      _this.searchAndAccount();
      _this.mainMenu();
      return _this.mobileMenu();
    };

    Header.prototype.searchAndAccount = function() {
      var _this;
      _this = this;
      $('.searchbar-open').click(function() {
        $(this).closest('.menu').fadeOut(100, function() {
          $('.main-header .searchbar-container').fadeIn(200);
          return $('.main-header .searchbar-container .search-box').focus();
        });
        return false;
      });
      $('.searchbar-close').click(function() {
        $('.main-header .searchbar-container').fadeOut(100, function() {
          return $('.search-account .menu').fadeIn(200);
        });
        return false;
      });
      $('.account-open').click(function() {
        $(this).closest('.menu').fadeOut(100, function() {
          return $('.account-container').fadeIn(200);
        });
        return false;
      });
      return $('.account-close').click(function() {
        $('.account-container').fadeOut(100, function() {
          return $('.search-account .menu').fadeIn(200);
        });
        return false;
      });
    };

    Header.prototype.mainMenu = function() {
      var HEADER, _this, container, dropdown_panel, links, main_header, main_menu_dropdown_timer, slideUpPanel, startTimer, stopResetTimer;
      _this = this;
      dropdown_panel = $(".main-menu-dropdown-panel .row");
      HEADER = $('.main-header');
      main_header = $(".template-index .main-header");
      container = $('.main-header .menu-container');
      links = container.find('.nav-item').has('.sub-nav').addClass('dropdown').find('> a');
      links.append(theme.utils.addSymbol('expand-more'));
      container.find('.nav-item').has('.sub-nav ul').find('.columns').addClass('large-3');
      container.find('.nav-item').has('.sub-nav ul').find('.columns > a > span').wrap('<h3 class="title"></div>');
      HEADER.find(".main-menu .widescreen .dropdown > a").click(function() {
        var autoHeight, curHeight, dropdown, sub_nav;
        dropdown = $(this).parent();
        sub_nav = dropdown.find(".sub-nav .columns");
        if (PAGE.hasClass('template-index') && theme.utils.transparentMenuIsEnabled() && touchevents_exist) {
          if ($('.main-header').hasClass('dropdown-open')) {
            if (dropdown.hasClass("active")) {
              startTimer();
            }
          } else {
            $('.main-header .bg').fadeIn();
          }
        }
        if (dropdown.hasClass("active")) {
          slideUpPanel();
        } else if ($('.main-header').hasClass('dropdown-open')) {
          dropdown_panel.find(".columns").animate({
            opacity: 0
          }, 200);
          dropdown_panel.find('.columns').remove();
          HEADER.find(".main-menu .dropdown").removeClass('active');
          dropdown.addClass("active");
          sub_nav.clone().appendTo(".main-menu-dropdown-panel .row");
          dropdown_panel.find(".columns").delay(200).animate({
            opacity: 1
          }, 200);
          curHeight = dropdown_panel.height();
          autoHeight = dropdown_panel.css('height', 'auto').outerHeight();
          dropdown_panel.height(curHeight).animate({
            height: autoHeight
          }, 400);
        } else {
          dropdown_panel.find('.columns').remove();
          $('.main-header').addClass('dropdown-open');
          dropdown.addClass("active");
          sub_nav.clone().appendTo(".main-menu-dropdown-panel .row");
          dropdown_panel.slideDown(400, function() {
            return dropdown_panel.css("height", dropdown_panel.outerHeight());
          });
          dropdown_panel.find(".columns").delay(200).animate({
            opacity: 1
          }, 200);
        }
        return false;
      });
      slideUpPanel = function() {
        $('.main-header').removeClass('dropdown-open');
        dropdown_panel.find(".columns").animate({
          opacity: 0
        }, 200);
        return dropdown_panel.delay(200).slideUp(function() {
          HEADER.find(".main-menu .dropdown").removeClass('active');
          dropdown_panel.find('.columns').remove();
          return dropdown_panel.css('height', 'auto');
        });
      };
      main_menu_dropdown_timer = '';
      if (!touchevents_exist) {
        HEADER.mouseenter(function() {
          if (PAGE.hasClass('template-index') && theme.utils.transparentMenuIsEnabled()) {
            $('.main-header .bg').fadeIn();
          }
          return stopResetTimer();
        }).mouseleave(function() {
          if ($('.main-header').hasClass('dropdown-open')) {
            return startTimer();
          } else {
            if (PAGE.hasClass('template-index') && main_header.css("position") === "absolute") {
              return $('.main-header .bg').stop(true, true).fadeOut();
            }
          }
        });
      }
      startTimer = function() {
        return main_menu_dropdown_timer = setTimeout((function() {
          slideUpPanel();
          if (PAGE.hasClass('template-index') && theme.utils.transparentMenuIsEnabled()) {
            return $('.main-header .bg').delay(300).fadeOut();
          }
        }), 500);
      };
      return stopResetTimer = function() {
        return clearTimeout(main_menu_dropdown_timer);
      };
    };

    Header.prototype.mobileMenu = function() {
      var _this, dropdown_links, mobile_menu, mobile_menu_link;
      _this = this;
      mobile_menu_link = $('.mobile-tools .menu');
      mobile_menu = $('.mobile-menu');
      mobile_menu.find('.nav-item').has('.sub-nav').find('> .nav-item-link').addClass('dropdown-link');
      mobile_menu.find('.nav-item').has('.sub-nav').find('> .nav-item-link').append(theme.utils.addSymbol('plus') + theme.utils.addSymbol('minus'));
      mobile_menu.find('.nav-item').has('.sub-nav ul').find('.columns > a > span').css('text-transform', 'uppercase');
      dropdown_links = mobile_menu.find("a.dropdown-link");
      mobile_menu_link.click(function() {
        mobile_menu.toggle();
        return false;
      });
      return dropdown_links.click(function() {
        var sub_menu;
        sub_menu = $(this).closest('li').find('.sub-nav:eq(0)');
        sub_menu.slideToggle();
        $(this).find('.fw--icon--plus').toggle();
        $(this).find('.fw--icon--minus').toggle();
        return false;
      });
    };

    return Header;

  })();

  HorizontalTabs = (function() {
    function HorizontalTabs() {
      $('.tabs-horizontal.headings').each(function() {
        return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper horizontal'/>");
      });
      $('.tabs-horizontal.headings li').wrapInner('<div class="trigger"></div>');
      $('.tabs-horizontal.headings li .trigger').append('<div class="bg"></div>');
      $('.tabs-wrapper.horizontal').each(function() {
        var tab_content, tab_headings;
        tab_headings = $(this).find('.headings > li');
        tab_content = $(this).find('.tabs.content > li');
        tab_content.first().addClass('active');
        tab_headings.first().addClass('active');
        return tab_headings.on('click', function() {
          tab_headings.removeClass('active');
          tab_content.removeClass('active');
          $(this).addClass('active');
          return tab_content.eq($(this).index()).addClass('active');
        });
      });
    }

    return HorizontalTabs;

  })();

  InstagramFeed = (function() {
    function InstagramFeed(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    InstagramFeed.prototype.load = function() {
      var _this, access_token, getImages, items_to_load;
      _this = this;
      access_token = _this.root.data('instagramAccessToken');
      if (access_token.length < 1 || $('.instagram-widget').length < 1) {
        return false;
      }
      items_to_load = 6;
      if (!$('.twitter-widget').length && !$('.blog-widget').length) {
        items_to_load += 6;
        $('.instagram-widget .items').addClass('wide');
      }
      return getImages = (function() {
        return $.ajax({
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + access_token + '&count=' + items_to_load,
          success: function(response) {
            var data, i, img_src, j, ref, results;
            if (response.meta.code === 200) {
              data = response.data;
              results = [];
              for (i = j = 0, ref = items_to_load - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
                if (data[i]) {
                  img_src = data[i].images.low_resolution.url;
                  img_src = img_src.replace("http:", "https:");
                  results.push($('.instagram-widget .items').append('<a class="item" target="_blank" href="' + data[i].link + '"><img src="' + img_src + '" /></a>'));
                } else {
                  results.push(void 0);
                }
              }
              return results;
            } else {
              return $('.instagram-widget .items').append('<p class="error">' + response.meta.error_message + '</p><p class="colored-links">Check the <strong>Homepage - social feeds</strong> section in your <a target="_blank" href="/admin/themes">theme settings</a>.</p>');
            }
          },
          error: function(jqXHR, textStatus) {
            console.log(jqXHR);
            return console.log(textStatus);
          }
        });
      })();
    };

    return InstagramFeed;

  })();

  MediaQueries = (function() {
    function MediaQueries() {
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.listeners();
      _this.load();
    }

    MediaQueries.prototype.load = function() {
      var current_window;
      if ($("html").hasClass("lt-ie9")) {
        $.event.trigger("mediumWindow");
        return current_window = 'medium';
      } else if (window.matchMedia('only screen and (min-width: ' + mq_medium + 'px)').matches) {
        if (current_window !== 'large') {
          $.event.trigger("largeWindow");
          return current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
        if (current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return current_window = 'medium';
        }
      } else {
        if (current_window !== 'small') {
          $.event.trigger("smallWindow");
          return current_window = 'small';
        }
      }
    };

    MediaQueries.prototype.listeners = function() {
      var _this;
      _this = this;
      return WINDOW.on('resize.section-' + _this.section_id, _this.load);
    };

    return MediaQueries;

  })();

  Popup = (function() {
    function Popup(clazz) {
      var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, getImage, getNewsletter, getPageContent, getSocialIcons, getWrapper, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration;
      this.clazz = clazz;
      modal = null;
      modal_clazz = this.clazz;
      mask = $('.popup-modal-mask');
      storeExpiration = function() {
        var date, e, error1, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires
        };
        try {
          return localStorage[popup_config.storage_key] = JSON.stringify(object);
        } catch (error1) {
          e = error1;
          return false;
        }
      };
      resetExpiration = function() {
        localStorage.removeItem(popup_config.storage_key);
        return storeExpiration();
      };
      isExpired = function() {
        var expires, now, object;
        object = JSON.parse(localStorage[popup_config.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function() {
        var passed;
        passed = false;
        if (Storage === "undefined" || popup_config.test_mode) {
          passed = true;
        } else if (typeof localStorage[popup_config.storage_key] === "undefined") {
          passed = true;
          storeExpiration();
        } else {
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function() {
        return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible');
      };
      showMask = function() {
        mask.show();
        return PAGE.addClass("modal-on");
      };
      hideMask = function() {
        mask.hide();
        return PAGE.removeClass("modal-on");
      };
      getImage = function() {
        if (popup_config.show_image_enabled === false) {
          return "";
        }
        if (popup_config.image_link.length > 0) {
          return $('<div class="popup-image"> <a href="' + popup_config.image_link + '">' + popup_config.show_image_url + '</a> </div>');
        } else {
          return $('<div class="popup-image">').append(popup_config.show_image_url);
        }
      };
      getNewsletter = function() {
        var subscribe_module;
        if (popup_config.newsletter_enabled === false) {
          return "";
        }
        subscribe_module = $("<div id='subscribe_module'></div>").append($("#mailing-list-module > p").clone()).append($("#mailing-list-module #contact_form").clone()).append($("#mc-embedded-subscribe-form").clone());
        return subscribe_module;
      };
      getSocialIcons = function() {
        if (popup_config.social_icons_enabled === false) {
          return "";
        }
        return $(".social-follow").clone();
      };
      getCustomClasses = function() {
        var class_list;
        class_list = "";
        class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
        class_list += popup_config.page_content.length > 0 ? " has-page-content" : " has-no-page-content";
        class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
        class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
        return class_list;
      };
      getWrapper = function() {
        return '<dialog class="' + modal_clazz + ' popup-modal' + getCustomClasses() + '" />';
      };
      getPageContent = function() {
        var page_content;
        page_content = null;
        if (popup_config.page_content.length < 1) {
          return "";
        }
        $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
          return page_content = "<div class='page-contents'>" + data.page.body_html + "</div>";
        });
        return page_content;
      };
      fillSizeChartDialog = function() {
        var dialog;
        if ($('.popup-modal.size-chart').length < 1) {
          dialog = {
            wrapper: getWrapper()
          };
          PAGE.append($(dialog.wrapper).append($('.size-chart')));
        }
        return openDialog();
      };
      fillPopupDialog = function() {
        var dialog, getInnerContent, render;
        dialog = {
          wrapper: getWrapper(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons(),
          image: getImage()
        };
        getInnerContent = function() {
          if (popup_config.page_content.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
            return "";
          }
          return $("<div class='inner' />").append(dialog.body, dialog.newsletter, dialog.social_icons);
        };
        render = function() {
          PAGE.append($(dialog.wrapper).append(dialog.image, getInnerContent()));
          return openDialog();
        };
        if (popup_config.page_content.length > 0) {
          return $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
            dialog['body'] = "<div class='page-contents'>" + data.page.body_html + "</div>";
            return render();
          });
        } else {
          return render();
        }
      };
      checkContentOverflow = function() {
        return setTimeout((function() {
          if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
            return modal.imagesLoaded(function() {
              var dialog_height;
              dialog_height = $('dialog[class*="' + modal_clazz + '"]:last-of-type').outerHeight();
              if (dialog_height >= WINDOW.height()) {
                return PAGE.addClass('modal-unfix');
              } else {
                return PAGE.removeClass('modal-unfix');
              }
            });
          }
        }), 0);
      };
      ieCenter = function() {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px"
        });
      };
      openDialog = function() {
        modal = $('dialog[class*="' + modal_clazz + '"]');
        if ($("html").hasClass("ie9")) {
          ieCenter();
        }
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        return showMask();
      };
      eventListeners = function() {
        var removeAnimation;
        removeAnimation = function(event) {
          if (event.originalEvent.animationName === 'modal-close') {
            if (modal_clazz === 'popup') {
              return modal.remove();
            } else {
              return modal.removeClass('closed, completed');
            }
          } else {
            return modal.addClass('completed').removeClass('opened');
          }
        };
        DOC.on('click', '.popup-modal', function(e) {
          e.stopPropagation();
          if (e.target === this) {
            return closeDialog();
          }
        });
        $('.popup-modal-close').click(closeDialog);
        mask.click(closeDialog);
        modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
        WINDOW.resize(checkContentOverflow);
        DOC.keydown(function(e) {
          if (modal.hasClass('completed') && e.keyCode === 27) {
            return closeDialog();
          }
        });
        return $('dialog.popup-modal #contact_form').on('submit', function(event) {
          var form;
          form = this;
          modal = $(this).closest('.popup-modal');
          modal.find('.error, .success').remove();
          event.preventDefault();
          if (modal.find('input[type="email"]').val().length === 0) {
            modal.find('.inner').prepend('<p class="error">' + theme.translation.newsletter_email_blank + '</p>');
            return false;
          } else {
            modal.find('.inner > *').hide();
            modal.find('.inner').prepend('<p class="success">' + theme.translation.newsletter_success_message + '</p>').show();
            setTimeout(function() {
              return form.submit();
            }, 500);
          }
          return false;
        });
      };
      closeDialog = function() {
        modal.addClass('closed').removeClass('completed').removeClass('opened');
        return hideMask();
      };
      if (modal_clazz !== 'popup') {
        fillSizeChartDialog();
      } else {
        if (popup_config.enabled && passesExpiration() && (popup_config.page_content.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {
          setTimeout((function() {
            if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
              return fillPopupDialog();
            }
          }), popup_config.seconds_until * 1000);
        }
      }
    }

    return Popup;

  })();

  ProductGrid = (function() {
    function ProductGrid() {
      this.listeners = bind(this.listeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.listeners();
      _this.load();
    }

    ProductGrid.prototype.load = function() {
      var _this;
      _this = this;
      return _this.matchImageHeights();
    };

    ProductGrid.prototype.matchImageHeights = function() {
      var greatest_height, grid_items, product_grid, row_items, setRowHeights;
      product_grid = $('.product-grid');
      grid_items = product_grid.find('.product-item, .clearfix');
      row_items = [];
      greatest_height = 0;
      if (product_grid.closest('.product-slider').length) {
        return false;
      }
      setRowHeights = function(product_items) {
        $.each(product_items, function() {
          return $(this).find('.image-wrapper').height(greatest_height);
        });
        return greatest_height = 0;
      };
      return product_grid.imagesLoaded(function() {
        return grid_items.each(function(index) {
          var image;
          image = $(this).find('.image-wrapper img:first');
          if (image.height() > greatest_height) {
            greatest_height = image.height();
          }
          if ($(this).hasClass('clearfix')) {
            if (row_items.length > 1) {
              setRowHeights(row_items);
            }
            return row_items = [];
          } else if (index === grid_items.length - 1) {
            row_items.push($(this));
            return setRowHeights(row_items);
          } else {
            return row_items.push($(this));
          }
        });
      });
    };

    ProductGrid.prototype.listeners = function() {
      var _this;
      _this = this;
      return WINDOW.resize(function() {
        return _this.matchImageHeights();
      });
    };

    return ProductGrid;

  })();

  ProductModal = (function() {
    function ProductModal(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.modal = _this.root;
      _this.load();
    }

    ProductModal.prototype.load = function() {
      var _this, changeModal, closeModal, modal, modal_controls, modal_init, modal_length, modal_open, openModal, resizeModal;
      _this = this;
      modal = _this.modal;
      if ($('.modal').length && $('.product-page').data('productModalEnabled')) {
        modal_length = $("article .photos .photo").length;
        modal_init = false;
        modal_open = false;
        modal.find('.loading').spin('small');
        if (modal_length > 1) {
          modal.addClass("with-nav");
          modal_controls = modal.find('.control, .popup-modal-close');
        } else {
          modal_controls = modal.find('.popup-modal-close');
        }
        resizeModal = function() {
          var active_photo, height_ratio, image_height, image_width, width_ratio, window_height, window_width;
          active_photo = modal.find('.photo.active');
          image_width = active_photo.naturalWidth();
          image_height = active_photo.naturalHeight();
          window_width = WINDOW.width();
          window_height = WINDOW.height();
          width_ratio = image_width / window_width;
          height_ratio = image_height / window_height;
          if (width_ratio > height_ratio && width_ratio > .90) {
            image_width = image_width * .90 / width_ratio;
            image_height = image_height * .90 / width_ratio;
          } else if (width_ratio < height_ratio && height_ratio > .90) {
            image_width = image_width * .90 / height_ratio;
            image_height = image_height * .90 / height_ratio;
          }
          modal.css({
            'width': image_width,
            'height': image_height,
            'margin-top': -(image_height / 2),
            'margin-left': -(image_width / 2)
          });
          return active_photo.css({
            'height': image_height
          });
        };
        openModal = function(index) {
          var active_photo;
          modal_open = true;
          if (!modal_init) {
            $("article .photos .photo").each(function() {
              return modal.find(".slides").append($('<img />').attr('src', $(this).attr('href')).addClass('photo'));
            });
            modal_init = true;
          }
          $('.modal-mask').show();
          modal.fadeIn();
          active_photo = $(".modal img").eq(index);
          active_photo.addClass('active');
          return modal.find(".photo.active").imagesLoaded(function() {
            modal.find(".loading").hide();
            modal_controls.show();
            modal.find(".slides").show();
            return resizeModal();
          });
        };
        $('.photos .container').off().on('click', function() {
          var index;
          if (current_window === 'small') {
            return false;
          }
          index = $(this).find('.photo.active').index();
          return openModal(index);
        });
        closeModal = function() {
          modal_open = false;
          modal.find(".photo.active").removeClass("active");
          modal.css('display', 'none');
          return $('.modal-mask').fadeOut();
        };
        modal.find('.popup-modal-close').on('click', function() {
          return closeModal();
        });
        $('.modal-mask').on('click', function() {
          return closeModal();
        });
        changeModal = function(direction) {
          var active_index, active_photo, new_index, photo_length;
          active_photo = modal.find('.photo.active');
          active_index = modal.find('.photo.active').index();
          photo_length = modal.find('.photo').length;
          if (direction === 'prev') {
            if (active_index === 0) {
              new_index = photo_length - 1;
            } else {
              new_index = active_index - 1;
            }
          }
          if (direction === 'next') {
            if (active_index === photo_length - 1) {
              new_index = 0;
            } else {
              new_index = active_index + 1;
            }
          }
          active_photo.removeClass('active');
          modal_controls.hide();
          modal.find(".loading").delay(50).fadeIn(0);
          return modal.find('.photo').eq(new_index).imagesLoaded(function() {
            modal.find(".loading").stop(true, true).fadeOut(0);
            modal_controls.show();
            modal.find('.photo').eq(new_index).addClass('active');
            return resizeModal();
          });
        };
        modal.find('.prev').on('click', function() {
          return changeModal('prev');
        });
        modal.find('.next').on('click', function() {
          return changeModal('next');
        });
        modal.find('.slides').on('click', function() {
          return changeModal('next');
        });
        DOC.keydown(function(e) {
          if (modal_open) {
            if (e.keyCode === 37 && modal_length > 1) {
              changeModal('prev');
            }
            if (e.keyCode === 39 && modal_length > 1) {
              changeModal('next');
            }
            if (e.keyCode === 27) {
              return closeModal();
            }
          }
        });
        if (modal_init) {
          return WINDOW.resize(function() {
            return resizeModal();
          });
        }
      }
    };

    return ProductModal;

  })();

  ProductSlider = (function() {
    function ProductSlider(root) {
      var _this;
      this.root = root;
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.product_grid = _this.root.find('.product-grid');
      _this.product_item = _this.root.find('.product-item');
      _this.load();
      _this.listeners();
    }

    ProductSlider.prototype.load = function() {
      var _this;
      _this = this;
      _this.product_grid.owlCarousel({
        items: 4,
        navigation: true,
        scrollPerPage: true,
        slideSpeed: 800,
        lazyLoad: true,
        pagination: false,
        navigationText: false
      });
      return _this.product_item.show();
    };

    ProductSlider.prototype.listeners = function() {
      var _this;
      _this = this;
      return WINDOW.on('resize.ProductSlider', _this.loadCarousel);
    };

    return ProductSlider;

  })();

  PromoBar = (function() {
    function PromoBar(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.promo_bar = _this.root;
      _this.close_btn = _this.root.find('button');
      _this.load();
    }

    PromoBar.prototype.load = function() {
      var _this;
      _this = this;
      if ((typeof Storage !== "undefined" && Storage !== null) && sessionStorage['promo-bar-closed']) {
        return _this.promo_bar.hide();
      } else {
        _this.promo_bar.show();
        return _this.close_btn.on('click', function() {
          return _this.close();
        });
      }
    };

    PromoBar.prototype.close = function() {
      var _this;
      _this = this;
      if ((typeof Storage !== "undefined" && Storage !== null) && !sessionStorage['promo-bar-closed']) {
        sessionStorage['promo-bar-closed'] = true;
      }
      return _this.promo_bar.addClass('closed');
    };

    return PromoBar;

  })();

  VerticalTabs = (function() {
    function VerticalTabs() {
      $('.tabs-vertical.headings').each(function() {
        return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper vertical'/>");
      });
      $('.tabs-vertical.headings li').wrapInner('<div class="trigger"></div>');
      $('.tabs-vertical.headings li .trigger').append('<div class="bg"></div>');
      $('.tabs-wrapper.vertical').each(function() {
        var tab_content, tab_headings, tab_wrapper;
        tab_wrapper = $(this);
        tab_headings = $(this).find('.headings > li');
        tab_content = $(this).find('.tabs.content > li');
        tab_content.first().addClass('active');
        tab_headings.first().addClass('active');
        return tab_headings.on('click', function() {
          tab_headings.removeClass('active');
          tab_content.removeClass('active');
          $(this).addClass('active');
          tab_content.eq($(this).index()).addClass('active');
          if (general_scroll_to_active_item) {
            if (matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches || $("html").hasClass("lt-ie9")) {
              return $('html, body').animate({
                scrollTop: tab_wrapper.offset().top - 50
              }, 'slow');
            } else {
              return $('html, body').animate({
                scrollTop: tab_wrapper.offset().top + tab_wrapper.find('.headings').outerHeight() - 50
              }, 'slow');
            }
          }
        });
      });
    }

    return VerticalTabs;

  })();

  VideoModal = (function() {
    function VideoModal(video) {
      this.createIframe = bind(this.createIframe, this);
      this.extractVideoId = bind(this.extractVideoId, this);
      this.extractVideoType = bind(this.extractVideoType, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.centerPosition = bind(this.centerPosition, this);
      this.close = bind(this.close, this);
      this.open = bind(this.open, this);
      this.opened = false;
      this.video = video;
      this.modal = $('.video.modal');
      this.player_button = video.find('.player-button');
      this.src_url = video.find('.play-button').attr('href');
      this.type = this.extractVideoType();
      this.id = this.extractVideoId();
      this.iframe = this.createIframe();
      this.caption = video.find('.caption');
    }

    VideoModal.prototype.open = function() {
      this.opened = true;
      this.modal.find(".flex-video").append(this.iframe);
      if (this.caption.length > 0) {
        this.modal.find(".caption").append(this.caption.html());
        this.modal.addClass("wide");
      } else {
        this.modal.find(".player").removeClass('large-8');
        this.modal.find('.caption').hide();
        this.modal.removeClass("wide");
      }
      this.player_button.hide();
      $('.modal-mask').show();
      this.modal.find('.close').show();
      this.modal.fadeIn();
      this.centerPosition();
      $(".modal").fadeIn(0);
      return this.eventListeners();
    };

    VideoModal.prototype.close = function() {
      this.opened = false;
      this.modal.find(".flex-video").empty();
      this.modal.find(".caption").empty();
      this.modal.hide();
      $('.modal-mask').fadeOut();
      if (this.caption.length === 0) {
        this.modal.find(".player").addClass('large-8');
        return this.modal.find('.caption').show();
      }
    };

    VideoModal.prototype.centerPosition = function() {
      if (WINDOW.height() < this.modal.outerHeight()) {
        return this.modal.css({
          'position': 'absolute',
          'top': '30px',
          'margin-top': 0,
          'margin-left': -(this.modal.outerWidth() / 2)
        });
      } else {
        return this.modal.css({
          'position': 'fixed',
          'top': '50%',
          'margin-top': -(this.modal.outerHeight() / 2),
          'margin-left': -(this.modal.outerWidth() / 2)
        });
      }
    };

    VideoModal.prototype.eventListeners = function() {
      var modal;
      modal = this;
      this.modal.find('.close').on('click', function() {
        return modal.close();
      });
      WINDOW.resize(function() {
        return modal.centerPosition();
      });
      DOC.keydown(function(e) {
        if (modal.opened) {
          if (e.keyCode === 27) {
            return modal.close();
          }
        }
      });
      $('.modal-mask').on('click', function() {
        return modal.close();
      });
      return this.player_button.on('click', function() {
        return false;
      });
    };

    VideoModal.prototype.extractVideoType = function() {
      var matches, re;
      re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(this.src_url);
      if (matches) {
        return 'youtube';
      } else {
        re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        matches = re.exec(this.src_url);
        if (matches) {
          return 'vimeo';
        }
      }
      return false;
    };

    VideoModal.prototype.extractVideoId = function() {
      var match, regExp;
      if (this.type === 'youtube') {
        regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = this.src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (this.type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = this.src_url.match(regExp);
        if (match) {
          return match[2];
        }
      }
    };

    VideoModal.prototype.createIframe = function() {
      if (this.type === "youtube") {
        return '<iframe  src="//www.youtube.com/embed/' + this.id + '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>';
      } else if (this.type === "vimeo") {
        return '<iframe src="//player.vimeo.com/video/' + this.id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
      }
    };

    return VideoModal;

  })();

  Cart = (function() {
    function Cart() {
      this.recentCartItemPopUp = bind(this.recentCartItemPopUp, this);
      this.addToCart = bind(this.addToCart, this);
      this.validateSize = bind(this.validateSize, this);
      this.stopResetTimer = bind(this.stopResetTimer, this);
      this.startTimer = bind(this.startTimer, this);
      this.fadeOutCartDropdown = bind(this.fadeOutCartDropdown, this);
      this.openMobileModal = bind(this.openMobileModal, this);
      this.slideDownCartDropdown = bind(this.slideDownCartDropdown, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.cart_dropdown_timer = null;
      _this.listeners();
    }

    Cart.prototype.load = function() {
      var _this;
      return _this = this;
    };

    Cart.prototype.listeners = function() {
      var _this;
      _this = this;
      $('.cart-form').off().on('submit', function() {
        _this.addToCart($(this));
        return false;
      });
      $('.recently-added.mobile .close').off().on('click', function() {
        return _this.fadeOutCartDropdown();
      });
      $('.recently-added-mask').off().on('click', function() {
        return _this.fadeOutCartDropdown();
      });
      $('.main-header .recently-added').mouseenter(function() {
        return _this.stopResetTimer();
      });
      return $('.main-header .recently-added').mouseleave(function() {
        return _this.startTimer();
      });
    };

    Cart.prototype.toggleCartDropdown = function() {
      return $('.main-header .recently-added').slideToggle('fast');
    };

    Cart.prototype.slideDownCartDropdown = function() {
      $('.main-header .recently-added').slideDown('fast');
      return $("html, body").animate({
        scrollTop: 0
      });
    };

    Cart.prototype.openMobileModal = function() {
      $('.main-header .recently-added.mobile').fadeIn();
      return $('.main-header .recently-added-mask').removeClass('hide');
    };

    Cart.prototype.fadeOutCartDropdown = function() {
      var _this;
      _this = this;
      clearTimeout(_this.cart_dropdown_timer);
      $('.main-header .recently-added').fadeOut('fast');
      return $('.main-header .recently-added-mask').addClass('hide');
    };

    Cart.prototype.startTimer = function() {
      var _this;
      _this = this;
      return _this.cart_dropdown_timer = setTimeout((function() {
        return _this.fadeOutCartDropdown();
      }), 4000);
    };

    Cart.prototype.stopResetTimer = function() {
      var _this;
      _this = this;
      return clearTimeout(_this.cart_dropdown_timer);
    };

    Cart.prototype.validateSize = function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    };

    Cart.prototype.addToCart = function(cart_form) {
      var _this, addToCartFail, addToCartPass;
      _this = this;
      addToCartPass = function(product) {
        return _this.recentCartItemPopUp();
      };
      addToCartFail = function(obj, status) {
        $('.recently-added .error').show();
        $('.recently-added table').hide();
        $('.recently-added div.row').hide();
        _this.slideDownCartDropdown();
        return _this.startTimer();
      };
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: cart_form.serialize(),
        success: addToCartPass,
        error: addToCartFail
      });
    };

    Cart.prototype.recentCartItemPopUp = function() {
      var _this, cart_item, cart_total;
      _this = this;
      cart_item = {};
      cart_total = {};
      if (currency_switcher_enabled) {
        Shopify.money_format = Currency.moneyFormats[theme.shop_currency].money_format;
      }
      return $.getJSON("/cart.js", function(cart, textStatus) {
        var new_cart_row, new_mobile_item;
        cart_item.image_url = Shopify.resizeImage(cart.items[0].image, "compact");
        cart_item.url = cart.items[0].url;
        cart_item.title = cart.items[0].title;
        cart_item.price = Shopify.formatMoney(cart.items[0].price, Shopify.money_with_currency_format);
        cart_total.price = Shopify.formatMoney(cart.total_price, Shopify.money_with_currency_format);
        cart_total.quantity = cart.item_count;
        $('.cart-link .number').html(cart_total.quantity);
        $('.cart-link .number-wrapper').removeClass('hide');
        new_cart_row = '<tr>';
        new_cart_row += '<td class="cart-item">';
        new_cart_row += '<a href="' + cart_item.url + '">';
        new_cart_row += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_cart_row += '</a>';
        new_cart_row += '</td>';
        new_cart_row += '<td class="cart-detail">';
        new_cart_row += '<h2><a href="' + cart_item.url + '">' + cart_item.title + '</a></h2>';
        new_cart_row += '</td>';
        new_cart_row += '<td class="cart-price"><span class="money">' + cart_item.price + '</span></td>';
        new_cart_row += '</tr>';
        new_mobile_item = '<a href="' + cart_item.url + '">';
        new_mobile_item += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_mobile_item += '</a>';
        $('.recently-added tbody').html(new_cart_row);
        $('.recently-added .mobile-item').html(new_mobile_item);
        $('.recently-added .items-count .number').html(cart_total.quantity);
        $('.recently-added .total-price').html(cart_total.price);
        if (currency_switcher_enabled) {
          $.each($('.recently-added .total-price').get(0).attributes, function(i, attrib) {
            if (attrib.name.match("^data-currency")) {
              return $('.recently-added .total-price').attr(attrib.name, "");
            }
          });
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        }
        $('.recently-added .error').hide();
        $('.recently-added table, .recently-added div.row').show();
        if ($('.main-header .mobile-tools').is(":hidden")) {
          _this.slideDownCartDropdown();
        } else {
          _this.openMobileModal();
        }
        return _this.startTimer();
      });
    };

    return Cart;

  })();

  Collection = (function() {
    function Collection() {
      DOC.on('change', '.tags-listbox', function() {
        var collFilters, newTags, query;
        newTags = [];
        collFilters = $(this);
        collFilters.each(function(index, element) {
          if ($(this).val()) {
            return newTags.push($(this).val());
          }
        });
        if (newTags.length) {
          query = newTags.join('+');
          return window.location.href = $(theme.collection.tag).attr('href').replace('tag', query);
        } else {
          if (theme.collection.handle) {
            return window.location.href = '/collections/' + theme.collection.handle;
          } else if (theme.collection.products.first_type === theme.collection.title) {
            return window.location.href = theme.collection.url_for_type;
          } else if (theme.collection.products.first_vendor === theme.collection.title) {
            return window.location.href = theme.collection.url_for_vendor;
          }
        }
      });
    }

    return Collection;

  })();

  Password = (function() {
    function Password() {
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.listeners();
      _this.load();
    }

    Password.prototype.load = function() {
      var _this;
      _this = this;
      if ($('.login-form .errors').size()) {
        return $('.login-link').click();
      }
    };

    Password.prototype.listeners = function() {
      var _this;
      _this = this;
      DOC.on('click', '.login-link', function() {
        $(this).css('visibility', 'hidden');
        $(".wrapper").hide();
        $('.login-form').css('visibility', 'visible').find($('[name=password]').focus());
        return false;
      });
      return DOC.on('click', '.login-form .cancel', function() {
        $(".login-link").css('visibility', 'visible');
        $(".wrapper").fadeIn();
        $('.login-form').css('visibility', 'hidden');
        return false;
      });
    };

    return Password;

  })();

  ProductPage = (function() {
    function ProductPage(root) {
      var _this;
      this.root = root;
      this.updateActiveImg = bind(this.updateActiveImg, this);
      this.load = bind(this.load, this);
      this.refreshSizeChart = bind(this.refreshSizeChart, this);
      this.reloadProductSection = bind(this.reloadProductSection, this);
      _this = this;
      _this.load();
    }

    ProductPage.prototype.reloadProductSection = function() {
      var _this;
      _this = this;
      new MediaQueries();
      _this.updateActiveImg(0);
      new ProductModal($('.modal'));
      _this.refreshSizeChart();
      $('article .thumbs').find('.thumb').on('click', function() {
        return _this.updateActiveImg($(this).index());
      });
      new Cart();
    };

    ProductPage.prototype.refreshSizeChart = function() {
      var _this, isSizeChartEnabled, len;
      _this = this;
      len = $(".single-option-selector").length;
      isSizeChartEnabled = function() {
        return $(".product-page").data("productSizeChartEnabled") === true;
      };
      if (len > 0) {
        return;
      }
      if (len < 1 && isSizeChartEnabled()) {
        return DOC.trigger('set-option-selectors');
      }
    };

    ProductPage.prototype.load = function() {
      var _this, getLowInStockAmount, getLowInStockMessage, photos, positions, showSizeChart, thumbs, updateLowInStock;
      _this = this;
      photos = $('article .photos');
      thumbs = $('article .thumbs');
      DOC.on('click', '.size-chart-trigger', function(e) {
        e.preventDefault();
        return new Popup('size-chart-container');
      });
      positions = (function() {
        var insertPosition;
        insertPosition = function(position_target) {
          var positions_src, target;
          positions_src = $('.positions.active');
          target = position_target;
          positions_src.find('[data-position]').each(function() {
            var elem_src, elem_target, position;
            position = $(this).attr('data-position');
            if (position.length) {
              elem_src = positions_src.find('[data-position="' + position + '"]');
              elem_target = target.find('[data-position="' + position + '"]');
              return elem_src.children().appendTo(elem_target);
            }
          });
          positions_src.removeClass('active');
          return position_target.addClass('active');
        };
        DOC.on("smallWindow", function() {
          return insertPosition($('.positions.show-for-small'));
        });
        DOC.on("mediumWindow", function() {
          return insertPosition($('.positions.show-for-medium-only'));
        });
        DOC.on("largeWindow", function() {
          return insertPosition($('.positions.show-for-large-up'));
        });
      })();
      photos.on('click', function() {
        return false;
      });
      getLowInStockMessage = function(quantity) {
        var message;
        message = quantity === 1 ? theme.products.low_in_stock.one : theme.products.low_in_stock.other;
        if (quantity > 1) {
          message = message.replace(/\d+/, quantity);
        }
        return message;
      };
      getLowInStockAmount = function() {
        return $('.product-page').data('product-low-in-stock-amount');
      };
      updateLowInStock = function(variant) {
        var quantity, threshold;
        quantity = variant.inventory_quantity;
        threshold = getLowInStockAmount();
        if (threshold === 'undefined') {
          return false;
        }
        if (quantity > 0 && quantity <= threshold) {
          $('.product-low-in-stock').html('<p>' + getLowInStockMessage(quantity) + '</p>').show();
        } else {
          $('.product-low-in-stock').hide();
        }
        return DOC.on('.shopify-section section--products shopify:section:select', function() {
          return updateLowInStock(variant);
        });
      };
      thumbs.find('.thumb').on('click', function() {
        return _this.updateActiveImg($(this).index());
      });
      showSizeChart = function(selector) {
        var product_options;
        if ($('.size-chart').length > 0) {
          $('.size-chart-trigger').remove();
          product_options = selector.product.options;
          $('.cart-form').addClass('size-chart-enabled');
          return $('.selector-wrapper').each(function(index, element) {
            var product_size_chart_option;
            product_size_chart_option = $('.product-page').data('productSizeChartOption').toLowerCase();
            if (product_options[index].toLowerCase() === product_size_chart_option) {
              return $(element).append('<a class="size-chart-trigger" href="#">' + theme.products.size_chart.label + '</a>');
            }
          });
        }
      };
      theme.variantSelected = function(variant, selector) {
        var actual_price, compare_price, product_options, show_low_in_stock, variant_image_index;
        product_options = null;
        $(".compare-price").html("");
        $('.product-unavailable [type="submit"]').prop("disabled", true);
        if (variant && variant.available) {
          $(".quanity-cart-row").show();
          $('.product-unavailable').hide();
        } else {
          $(".quanity-cart-row").hide();
          $('.product-unavailable').show();
          $('.product-low-in-stock').hide();
          $('.product-unavailable [type="submit"]').prop("disabled", false);
          if (product_variant_size > 1 && variant) {
            $('.product-unavailable form .email-body').attr('value', 'Please notify me when this is back in stock: ' + product_title + ' - ' + variant.title);
          }
        }
        if (variant) {
          actual_price = Shopify.formatMoney(variant.price, shop_money_format);
          $(".actual-price").replaceWith('<span class="actual-price money" itemprop="price">' + actual_price + '</span>');
          if (variant.compare_at_price > variant.price) {
            compare_price = Shopify.formatMoney(variant.compare_at_price, shop_money_format);
            $(".compare-price").html(product_language_was + ' <span class="money">' + compare_price + '</span>');
          }
          if (currency_switcher_enabled) {
            Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
          }
          if (variant.featured_image) {
            variant_image_index = $('article .photos .photo[data-image-id="' + variant.featured_image.id + '"]').index();
            _this.updateActiveImg(variant_image_index);
          } else {
            _this.updateActiveImg(0);
          }
          showSizeChart(selector);
          show_low_in_stock = getLowInStockAmount() === false ? false : true;
          if (show_low_in_stock === true && variant.inventory_management === "shopify") {
            updateLowInStock(variant);
          }
        }
      };
      // end of selectCallback;
      $("article .custom.dropdown").hide();
      if (product_options_size === 1 && product_options_first !== "Title") {
        $(".selector-wrapper:eq(0)").prepend("<label>" + product_options_first + "</label>");
      }
      $(".selector-wrapper .single-option-selector").each(Foundation.libs.forms.append_custom_select);
      return $("select.single-option-selector").change(function() {
        Foundation.libs.forms.refresh_custom_select($(this), true);
      });
    };

    ProductPage.prototype.updateActiveImg = function(index) {
      var _this, imgZoom, isProductZoomEnabled, photos, thumbs, transition_time;
      _this = this;
      photos = $('article .photos');
      thumbs = $('article .thumbs');
      isProductZoomEnabled = function() {
        return $('.product-page').data('productZoomEnabled');
      };
      imgZoom = function(index) {
        if (!touchevents_exist && isProductZoomEnabled()) {
          return photos.find('.container').zoom({
            url: photos.find('.photo').eq(index).attr('data-zoom')
          });
        }
      };
      if (!touchevents_exist && isProductZoomEnabled()) {
        photos.find('.container').on("mouseover", function() {
          $(this).css('outline-width', 1);
          return photos.find('.zoomImg').css({
            opacity: 1
          });
        }).on("mouseleave", function() {
          return $(this).css('outline-width', 0);
        });
      }
      if (photos.find('.photo').eq(index).find('img').length < 1) {
        return;
      }
      if (photos.find('.photo.active').index() === index) {
        return;
      }
      thumbs.find('.thumb').removeClass('active');
      thumbs.find('.thumb').eq(index).addClass('active');
      photos.find('.zoomImg').remove();
      transition_time = 0;
      if (photos.find('.photo.active').length) {
        transition_time = 300;
        photos.find('.photo.active').fadeOut(transition_time).removeClass('active');
      }
      photos.find('.photo').eq(index).delay(transition_time).imagesLoaded(function() {
        var container_width, height, width;
        imgZoom(index);
        height = photos.find('.photo').eq(index).find('img').naturalHeight();
        width = photos.find('.photo').eq(index).find('img').naturalWidth();
        container_width = photos.outerWidth();
        if (container_width < width) {
          height = container_width / width * height;
          width = container_width;
        }
        photos.find('.container').animate({
          "height": height,
          "width": width
        }, transition_time, function() {
          return photos.find('.container').css({
            'height': 'auto',
            'width': 'auto'
          });
        });
        return photos.find('.photo').eq(index).addClass('active').fadeIn(transition_time);
      });
    };

    return ProductPage;

  })();

  $(document).foundation();

  PAGE = null;

  DOC = null;

  WINDOW = null;

  HEADER = null;

  touchevents_exist = null;

  mq_small = null;

  mq_medium = null;

  mq_large = null;

  log = null;

  current_window = '';

  jQuery(function($) {
    var first_article_img, isFirefox, page_content, pinterest_button;
    PAGE = $('body');
    DOC = $(document);
    WINDOW = $(window);
    HEADER = $('.main-header');
    touchevents_exist = Modernizr.touchevents;
    mq_small = 768;
    mq_medium = 1280;
    mq_large = 1440;
    log = function(value) {
      if (typeof console !== "undefined") {
        return console.log(value);
      }
    };
    theme.utils = {};
    theme.utils.addSymbol = function(icon_name) {
      return '<svg class="fw--icon fw--icon--' + icon_name + '"> <use xlink:href="#fw--icon--' + icon_name + '" /> </svg>';
    };
    theme.utils.loadJsClasses = function() {
      return $('[data-js-class]').each(function() {
        var partial_class;
        if ($(this).attr('data-js-loaded') !== 'true') {
          partial_class = theme.classes[$(this).attr('data-js-class')];
          if (typeof partial_class !== "undefined") {
            new partial_class($(this));
            return $(this).attr('data-js-loaded', 'true');
          }
        }
      });
    };
    theme.utils.transparentMenuIsEnabled = function() {
      return PAGE.find("[data-has-transparent-menu=true]").length > 0;
    };
    if (general_external_links_enabled) {
      $('a[href^="http"]').not('a[href^="' + shop_url + '"]').attr('target', '_blank');
    }
    if (popup_config.enabled) {
      $.preloadImages = function() {
        var i;
        i = 0;
        while (i < arguments.length) {
          $('<img />').attr('src', arguments[i]);
          i++;
        }
      };
      $.preloadImages(theme.preload_image);
    }
    new Popup('popup');
    if (PAGE.hasClass('template-product')) {
      theme.product_page = new ProductPage($('.product-page'));
    }
    new Footer($('.footer'));
    theme.header = new Header($('.header'));
    theme.product_modal = new ProductModal($('.modal'));
    new Accordion();
    new HorizontalTabs();
    new VerticalTabs();
    new Cart();
    new PromoBar($('.promo-bar'));
    if (PAGE.hasClass('template-page')) {
      page_content = $('.page-content .rte-content');
      if (page_content.find('.left-side-column').length || page_content.find('.right-side-column').length) {
        if (page_content.find('.left-side-column').length && page_content.find('.right-side-column').length) {
          page_content.wrapInner("<div class='main-column with-2-sidebars'></div>");
          $('.left-side-column').addClass('with-2-sidebars');
          $('.right-side-column').addClass('with-2-sidebars');
        } else {
          page_content.wrapInner("<div class='main-column'></div>");
        }
        $('.left-side-column').prependTo(page_content);
        $('.right-side-column').appendTo(page_content);
      }
    }
    if (PAGE.hasClass('template-index')) {
      $('.slider').each(function() {
        return new FullscreenSlider($(this).find('.slides'));
      });
      $('.product-slider').each(function() {
        return new ProductSlider($(this));
      });
      new InstagramFeed($('.instagram-widget'));
    }
    if (PAGE.hasClass('template-collection')) {
      new Collection();
    }
    if (PAGE.hasClass('template-article')) {
      pinterest_button = $('.social-share .pinterest');
      first_article_img = $('.article img').first().attr('src');
      pinterest_button.attr('href', pinterest_button.attr('href') + '&media=' + first_article_img);
    }
    if ($('.section--password').length > 0) {
      new Password();
    }
    isFirefox = typeof InstallTrigger !== "undefined";
    if (isFirefox) {
      $('img').addClass('image-scale-hack');
    }
    if (touchevents_exist) {
      $("form.custom .hidden-field").removeClass('hidden-field');
    }
    current_window = '';
    new MediaQueries();
    $('.hide-until-js').show();
    new ProductGrid();
    window.twttr = (function(d, s, id) {
      var fjs, js, t;
      js = void 0;
      fjs = d.getElementsByTagName(s)[0];
      t = window.twttr || {};
      if (d.getElementById(id)) {
        return t;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://platform.twitter.com/widgets.js';
      fjs.parentNode.insertBefore(js, fjs);
      t._e = [];
      t.ready = function(f) {
        t._e.push(f);
      };
      return t;
    })(document, 'script', 'twitter-wjs');
    DOC.on('shopify:section:load', function(e) {
      var section_wrapper;
      section_wrapper = $(e.target).closest('.shopify-section');
      section_wrapper.css('min-height', '2000px');
      if (section_wrapper.hasClass('section--slideshow')) {
        new FullscreenSlider($(e.target).find('.slides'));
      } else if (section_wrapper.hasClass('section--featured-collection')) {
        new ProductSlider($(e.target).find('.product-slider'));
      } else if (section_wrapper.hasClass('social-feeds')) {
        new InstagramFeed($('.instagram-widget'));
        twttr.widgets.load();
      } else if (section_wrapper.hasClass('section--header')) {
        theme.header.mainMenu();
        theme.header.mobileMenu();
        setTimeout(function() {
          if ($('.slider').length > 0) {
            return DOC.trigger('header.transparentMenuIsUpdated');
          }
        }, 0);
        new PromoBar($('.promo-bar'));
      } else if (section_wrapper.hasClass('section--products')) {
        DOC.trigger('set-option-selectors');
        new ProductModal($('.modal'));
      }
      return section_wrapper.css('min-height', 'auto');
    });
    DOC.on('shopify:section:unload', function(e) {
      var mask, section_wrapper;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--featured-collection')) {
        return setTimeout((function() {
          if ($('.section--featured-collection').length === 0) {
            return WINDOW.off("resize.ProductSlider");
          }
        }), 0);
      } else if (section_wrapper.hasClass('section--products')) {
        mask = $(".popup-modal-mask");
        $(".size-chart").remove();
        if (mask.is(":visible")) {
          return mask.trigger("click");
        }
      } else if (section_wrapper.hasClass('section--slideshow')) {
        return setTimeout(function() {
          if ($('.slider').length === 0) {
            return DOC.off('header.transparentMenuIsUpdated');
          }
        }, 0);
      }
    });
    DOC.on('shopify:section:select', function(e) {
      var section_wrapper;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--products')) {
        current_window = '';
        return theme.product_page.reloadProductSection();
      }
    });
    DOC.on('shopify:block:select', function(e) {
      var section_wrapper, slide_selected;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--slideshow')) {
        slide_selected = section_wrapper.find('.slide').index(e.target);
        return $(e.target).closest('.owl-carousel').trigger('owl.jumpTo', slide_selected).trigger('owl.stop');
      }
    });
    DOC.on('shopify:section:deselect', function(e) {
      var section_wrapper, should_autoplay, slider;
      section_wrapper = $(e.target).closest('.shopify-section');
      if (section_wrapper.hasClass('section--slideshow')) {
        should_autoplay = section_wrapper.find('.slider').data('autoplay');
        if (should_autoplay === true) {
          slider = section_wrapper.find('.slides');
          return slider.trigger('owl.play', section_wrapper.find('.slider').data('rotateFrequency'));
        }
      }
    });
    return false;
  });

}).call(this);


// jQuery(document).ready(function(){
//     // This button will increment the value
//     $('.qtyplus').click(function(e){
//         // Stop acting like a button
//         e.preventDefault();
//         // Get the field name
//         fieldName = $(this).attr('field');
//         // Get its current value
//         var currentVal = parseInt($('input[id='+fieldName+']').val());
//         // If is not undefined
//         if (!isNaN(currentVal)) {
//             // Increment
//             $('input[id='+fieldName+']').val(currentVal + 1);
//         } else {
//             // Otherwise put a 0 there
//             $('input[id='+fieldName+']').val(0);
//         }
//     });
//     // This button will decrement the value till 0
//     $(".qtyminus").click(function(e) {
//         // Stop acting like a button
//         e.preventDefault();
//         // Get the field name
//         fieldName = $(this).attr('field');
//         // Get its current value
//         var currentVal = parseInt($('input[id='+fieldName+']').val());
//         // If it isn't undefined or its greater than 0
//         if (!isNaN(currentVal) && currentVal > 0) {
//             // Decrement one
//             $('input[id='+fieldName+']').val(currentVal - 1);
//         } else {
//             // Otherwise put a 0 there
//             $('input[id='+fieldName+']').val(0);
//         }
//     });
// });  
// jQuery(document).ready(function(){
//     // This button will increment the value
//     $('.qtyplus').click(function(e){
//         // Stop acting like a button
//         e.preventDefault();
//         // Get the field name
//         fieldName = $(this).attr('field');
//         // Get its current value
//         var currentVal = parseInt($('input[name='+fieldName+']').val());
//         // If is not undefined
//         if (!isNaN(currentVal)) {
//             // Increment
//             $('input[name='+fieldName+']').val(currentVal + 1);
//         } else {
//             // Otherwise put a 0 there
//             $('input[name='+fieldName+']').val(0);
//         }
//     });
//     // This button will decrement the value till 0
//     $(".qtyminus").click(function(e) {
//         // Stop acting like a button
//         e.preventDefault();
//         // Get the field name
//         fieldName = $(this).attr('field');
//         // Get its current value
//         var currentVal = parseInt($('input[name='+fieldName+']').val());
//         // If it isn't undefined or its greater than 0
//         if (!isNaN(currentVal) && currentVal > 0) {
//             // Decrement one
//             $('input[name='+fieldName+']').val(currentVal - 1);
//         } else {
//             // Otherwise put a 0 there
//             $('input[name='+fieldName+']').val(0);
//         }
//     });
// });

